import React, { useState } from 'react'
import { Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Select } from '@material-ui/core';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { useDispatch ,useSelector } from "react-redux";
import { putBulkUpdate } from '../thunks/putBulkUpdate';
import { useHistory } from 'react-router-dom';
import swal from 'sweetalert';
import { setSearchAllV2 } from "../../contractManagement/AppStore/ActionCreator/commonDataAction";
import CustomDateInput from '../../components/common components/CustomDateInput';
import icon_child from '../../_theme/_assets/images/icon__child.svg';
import icon_adult from '../../_theme/_assets/images/icon_adult.svg';
import icon_childfriendly from '../../_theme/_assets/images/icon_sharp-child-friendly.svg';
import { showDetailedErrorSwal } from '../../components/common components/showErrorSwal';
import { normalizeTicketingDateEntries } from '../helpers/normalizeTicketingDateEntries';
import { createBlackOutCarrierPayload, reverseBlackOutCarrierPayload, applyAction, BLACKOUT_CARRIER_ACTION } from './Constant';

const BulkUpdate = () => {
    const dispatch = useDispatch()
    const [origins, setOrigins] = useState("");
    const [destinations, setDestinations] = useState("");
    const [marketingAirline, setMarketingAirline] = useState("");
    const [mappedOpeartingAirlines, setMappedOpeartingAirlines] = useState("");
    const [maximumFeeCCAmoutByCarrier, setMaximumFeeCCAmoutByCarrier] = useState("");
    const [maximumFeeCCBycarrierType, setMaximumFeeCCBycarrierType] = useState("");
    const [note, setNote] = useState("");
    const [ccFeesForTBMerchant, setCcFeesForTBMerchant] = useState("");
    const [landFare, setLandFare] = useState(null);
    const [cruiseFare, setCruiseFare] = useState(null);
    const [cabinType, setCabinType] = useState([]);
    const [tripType, setTripType] = useState("");
    const [isBrandedFare, setIsBrandedFare] = useState("");
    const [distribution, setDistribution] = useState([])
    const [formsOfPayment, setFormsOfPayment] = useState([]);
    const [tariffDisabled, setTariffDisabled] = useState("");
    const [tariffOwner, setTariffOwner] = useState("");
    const [calculationBasis, setCalculationBasis] = useState("");
    const [distributionChannels, setDistributionChannels] = useState([]);
    const [old_tarfPCC_VIT,setOld_tarfPCC_VIT] = useState("");
    const [tarifPCC_FUN,setTarifPCC_FUN] = useState("");
    const [tarifPCC_SKY,setTarifPCC_SKY] = useState("");
    const [tarifPCC_TC,setTarifPCC_TC] = useState("");
    const [tarifPCC_DFW,setTarifPCC_DFW] = useState("");
    const [disallowedAirports, setDisallowedAirports] = useState([]);
    const [skipRoutingCheck, setSkipRoutingCheck] = useState("");

    // Class related fields

    const [brandCode, setBrandCode] = useState("")
    const [classCodes, setClassCodes] = useState("")
    const [category, setCategory] = useState("")
    const [contractType, setContractType] = useState("")
    const [ticketingFee, setTicketingFee] = useState("")
    const [classNote, setClassNote] = useState("")
    const [minmaxStay, setMinmaxStay] = useState("")
    const [classLastTicketingDate, setClassLastTicketingDate] = useState(null)
    const fareOptions = [
        { label: "ADT Public", value: "ADT public" },
        { label: "ADT Private", value: "ADT prive" },
        { label: "JCB", value: "JCB" },
        { label: "PFA", value: "PFA" },
        { label: "ITX", value: "ITX" },
    ];
    const [classCodeDescription, setClassCodeDescription] = useState("")


    //Class Rules
    const [ageRestrictionsInfantAge, setAgeRestrictionsInfantAge] = useState("")
    const [ageRestrictionsInfantAgeApplicableOn, setAgeRestrictionsInfantAgeApplicableOn] = useState("")
    const [ageRestrictionsChildAge, setAgeRestrictionsChildAge] = useState("")
    const [juniorAgeFrom, setJuniorAgeFrom] = useState(0)
    const [juniorAgeTo, setJuniorAgeTo] = useState(0)
    const [ageRestrictionsNoTicketingForInfant, setAgeRestrictionsNoTicketingForInfant] = useState(false)
    const [osi, setOsi] = useState("")
    const [permitBranchPNR, setpermitBranchPNR] = useState(false)

    //Class Ticket By / Changes
    const [optionRulesDepartureWindow, setOptionRulesDepartureWindow] = useState("")
    const [optionRulesDaysAfterReservation, setOptionRulesDaysAfterReservation] = useState("")
    const [optionRulesDaysBeforeDeparture, setOptionRulesDaysBeforeDeparture] = useState("")
    const [ticketingRulesDepartureWindow, setTicketingRulesDepartureWindow] = useState("")
    const [ticketingRulesDaysAfterReservation, setTicketingRulesDaysAfterReservation] = useState("")
    const [ticketingRulesDaysBeforeDeparture, setTicketingRulesDaysBeforeDeparture] = useState("")
    const optionDate = {
        departureWindow: '',
        daysAfterReservation: '',
        daysBeforeDeparture: ''
    }
    const ticketDate = {
        departureWindow: '',
        daysAfterReservation: '',
        daysBeforeDeparture: ''
    }
    let [optionDates, setOptionDates] = useState([optionDate]);
    let [ticketDates, setTicketDates] = useState([ticketDate]);

    //Class Routing
    const [classRoutings, setClassRoutings] = useState("")

    //Class Price at Sabre
    const [disableAutoTicketing, setDisableAutoTicketing] = useState(null)
    const [disablePriceUnitConcept , setDisablePriceUnitConcept ] = useState(null)
    const [issueAsBulk , setIssueAsBulk ] = useState(false)
    const [fareType, setFareType] = useState("")
    const [accountCodeVIT, setAccountCodeVIT] = useState("")
    const [accountCodeSKY, setAccountCodeSKY] = useState("")
    const [accountCodeDFW, setaccountCodeDFW] = useState("")
    const [accountCodeFUN, setaccountCodeFUN] = useState("")
    const [accountCodeTC, setaccountCodeTC] = useState("")
    const [ticketDesignatorVIT, setTicketDesignatorVIT] = useState("")
    const [ticketDesignatorSKY, setTicketDesignatorSKY] = useState("")
    const [ticketDesignatorDFW, setTicketDesignatorDFW] = useState("")
    const [ticketDesignatorTC, setTicketDesignatorTC] = useState("")
    const [ticketDesignatorFUN, setTicketDesignatorFUN] = useState("")

    //Class Remarks
    const [remarksVITENG, setRemarksVITENG] = useState("")
    const [remarksVITFR, setRemarksVITFR] = useState("")
    const [remarksSKYENG, setRemarksSKYENG] = useState("")
    const [remarksSKYFR, setRemarksSKYFR] = useState("")
    const [remarksFUNENG, setRemarksFUNENG] = useState("")
    const [remarksFUNFR, setRemarksFUNFR] = useState("")
    const [remarksTCENG, setRemarksTCENG] = useState("")
    const [remarksTCFR, setRemarksTCFR] = useState("")
    const [remarksDFWENG, setRemarksDFWENG] = useState("")
    const [remarksDFWFR, setRemarksDFWFR] = useState("")

    //Prix
    const [validFrom, setValidFrom] = useState(null)
    const [validTo, setValidTo] = useState(null)
    const [prixLastReturnDate, setPrixLastReturnDate] = useState(null)
    const [prixLastTicketingDate, setPrixLastTicketingDate] = useState(null)
    const [prixNote, setPrixNote] = useState("")
    const [commissionPercentage, setCommissionPercentage] = useState("");
    const [childCommissionPercentage, setChildCommissionPercentage] = useState("");
    const [infantCommissionPercentage, setInfantCommissionPercentage] = useState("");
    const [passBackCommission, setPassBackCommission] = useState("")
    const [childPassBackCommission, setChildPassBackCommission] = useState("")
    const [infantPassBackCommission, setInfantPassBackCommission] = useState("")

    //Prix Price
    const [adultCommissionOnYQ, setAdultCommissionOnYQ] = useState("")
    const [childCommissionOnYQ, setChildCommissionOnYQ] = useState("")
    const [enfantCommissionOnYQ, setEnfantCommissionOnYQ] = useState("")
    const [markup, setmarkup] = useState("")
    const [childMarkup, setChildMarkUp] = useState("")
    const [infantMarkUp, setInfantMarkUp] = useState("")
    const [adultPassBackCommissionOnYQ, setadultPassBackCommissionOnYQ] = useState("")
    const [childPassBackCommissionOnYQ, setChildPassBackCommissionOnYQ] = useState("")
    const [enfantPassBackCommissionOnYQ, setEnfantPassBackCommissionOnYQ] = useState("")
    const [adultMinSelling, setAdultMinSelling] = useState("")
    const [childMinSelling, setChildMinSelling] = useState("")
    const [infantMinSelling, setInfantMinSelling] = useState("")
    const [minumumSellingPrice, setMinumumSellingPrice] = useState("")

    //Prix Navcan
    const [adultCommissionOnYQNav, setAdultCommissionOnYQNav] = useState("")
    const [childCommissionOnYQNav, setChildCommissionOnYQNav] = useState("")
    const [enfantCommissionOnYQNav, setEnfantCommissionOnYQNav] = useState("")
    const [adultPassBackCommissionOnYQNav, setAdultPassBackCommissionOnYQNav] = useState("")
    const [childPassBackCommissionOnYQNav, setChildPassBackCommissionOnYQNav] = useState("")
    const [enfantPassBackCommissionOnYQNav, setEnfantPassBackCommissionOnYQNav] = useState("")
    

    //Prix Exceptions


    //Prix Emissions
    const [endorsementVIT, setEndorsementVIT] = useState("")
    const [endorsementSKY, setEndorsementSKY] = useState("")
    const [endorsementDFW, setEndorsementDFW] = useState("")
    const [endorsementFUN, setEndorsementFUN] = useState("")
    const [endorsementTC, setEndorsementTC] = useState("")
    
    const [formatFields, setFormatFields] = React.useState({
        "classes": false
    })
    const regex = /^(?:\{\s*\*?\s*[A-Z]?(?:\s*,\s*[A-Z])*\s*\}|\*|[A-Z](?:\s*,\s*[A-Z])*)$/;
    //Additional
    const blackoutDate = {"fromDate":"","toDate":"","aller":undefined,"retour":undefined,"exceptionType":"","isMarkedForDelete": false}
    const [blackoutDatesRepetative, setBlackoutDatesRepetative] = useState([{...blackoutDate}])

    const blackoutDay = {"day":"","aller":undefined,"retour":undefined,"exceptionType":"","isMarkedForDelete": false}
    const [blackoutDaysRepetative, setBlackoutDaysRepetative] = useState([{...blackoutDay}])

    const blackoutAirline = {"flightNumberFrom":"","flightNumberTo":"","carrierCode":"","aller":undefined,"retour":undefined,"exceptionType":"", isMarkedForDelete: false}
    const [blackoutAirlinesRepetative, setBlackoutAirlinesRepetative] = useState([{...blackoutAirline}])
    const tourCodeDropdown =[
        "YMQ",
        "YOW",
        "YQB",
        "YTO",
        "SKY",
        "YVR",
        "YHZ",
        "YOW_SKY",
        "FUN",
        "YVR_TC",
        "FYVR_TCUN",
        "YTO_TC",
        "YTO_TCUN"
    ]
    const tourCode = {
        "tourCodes": "",
        "marketCode": "",
        "passengerType": [],
        "isMarkedForDelete": false
    }

    const checkBoxMappings = {
        'Business': 'Business',
        'Economy': 'Economy',
        'Premium Business': 'PremiumBusiness',
        'Premium Economy': 'PremiumEconomy',
        'First': 'First',
        'Cheque': 'CHEQUE',
        'Credit Card': 'CREDITCARD',
        'Credit Internal': 'CREDITINTERNAL',
        'Sky Link': 'Sky Link',
        'Intair Transit': 'Intair Transit',
        'Fun Sun': 'Fun Sun',
        'DFW': 'DFW',
        'Sunquest': 'Sunquest',
        'Network': 'Network'
    }

    const businessCabin = ['Business', 'PremiumBusiness', 'First']
    const economyCabin = ['Economy', 'PremiumEconomy']

    const [tourCodeRepetative, setTourCodeRepetative] = useState([{...tourCode}])

    const [bulkEmpty, setBulkEmpty] = useState({
        "marketingAirline": false,
        "operatingAirline": false,
        "airportNotAllowed": false,
        "cannotBeDistributed": false,
        "distribution": false,
        "PCCDuTariff": false,
        "OSI": false,
        "branchFiles": false,
        "issueAsBulk": false,
        "accountCode": false,
        "ticketDesignator": false,
        "lastReturnDate": false,
        "lastTicketingDate": false,
        "endorsement": false,

    });

    const handleBulkEdit = (name) => {
        let copyBulkEdit = { ...bulkEmpty };
        copyBulkEdit[name] = !(copyBulkEdit[name]);
        setBulkEmpty(copyBulkEdit);
    }

    const onChangeForMultiple = (value, index, key, initialArray, setArray) => {
        let temp = [...initialArray]
        Object(temp[index])[key] = value
        setArray([...temp])
    }

  const checkBoxObject = useSelector((state) => state.commonDataReducer.checkBoxObject);
  const history = useHistory();
  let blackoutpayload = createBlackOutCarrierPayload(checkBoxObject?.blackOutCarrier);
  const [nestedPayload, setNestedPayload] = useState(blackoutpayload || {});
  let existingBlackoutDates = checkBoxObject?.blackoutDate && Object.values(checkBoxObject?.blackoutDate)[0];
  let existingBlackoutDays = checkBoxObject?.blackoutDay && Object.values(checkBoxObject?.blackoutDay)[0];
  let existingTourCodes = checkBoxObject?.tourCode && Object.values(checkBoxObject?.tourCode)[0];
  console.log("checkBoxObject2", checkBoxObject, existingBlackoutDates, existingBlackoutDays, existingTourCodes)

  const blackOutCarrierCTA = async (action, index = null, extraValue = null) => {
    if(action === BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT && !extraValue) {
        return;
    }
    if(action === BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT) {
      const regex = /^([A-Z0-9]{2})\s+(\d{1,8}(?:-\d{1,8})?(?:\s*,\s*\d{1,8}(?:-\d{1,8})?)*)$/;
        const match = extraValue.match(regex);
        if(!match){
          swal({
            title: "Error",
            text: "Please provide a valid display text.(e.g. AC 1234-5678, 2345)",
            icon: "error",
            button: "OK",
          });
          return;
        }
        // const newCarrier = match[1];
        // let data = JSON.parse(JSON.stringify(blackoutAirlinesRepetative));
        // if (data[index].carrierCode !== newCarrier) {
        //     data[index].aller = 0;
        //     data[index].retour = 0;
        //     setBlackoutAirlinesRepetative(data);
        // }
    }
    if(action === BLACKOUT_CARRIER_ACTION.DELETE_INDEX ) {
        let payload = { ...nestedPayload };
        let [key, value] = Object.entries(payload)[0];
        value.splice(index, 1);
        let modifiedPayload = { [key]: value };
        setNestedPayload(modifiedPayload);
        console.log("=>>updatedPayload", modifiedPayload);
        return;
    }

    const updatedPayload = applyAction(nestedPayload, action, index, extraValue, blackoutAirlinesRepetative, setBlackoutAirlinesRepetative);
    setNestedPayload(updatedPayload);
    const reverseBlackoutpayload = reverseBlackOutCarrierPayload(updatedPayload);
    console.log("=>>updatedPayload", updatedPayload);
    console.log("=>>reverseBlackoutResponsePayload", reverseBlackoutpayload);
  };

  /**
 * Merges existing values with latest (local) values based on index.
 *
 * Rules:
 * 1. If index exists in both:
 *      a. If isMarkedForDelete = true → remove that entry.
 *      b. Else if modified → update the entry.
 * 2. If index exists only in local values → add as new entry.
 * 3. Return final merged array.
 */
function mergeValues(existingValues = [], localValues = [], defaultObject = {}) {
    const finalList = [...existingValues];

    localValues.forEach((localItem, index) => {
        const exists = index < existingValues.length;

        if (exists) {
            // UPDATE (only if any key is modified)
            const existingItem = existingValues[index];
            const isModified = Object.keys(defaultObject).some(
                key => localItem[key] !== undefined && localItem[key] !== existingItem[key]
            );

            if (isModified) {
                finalList[index] = { ...existingItem, ...localItem };
            } else {
                finalList[index] = existingItem;
            }

        } else {
            // ADD new row (only if not marked for delete)
            if (!localItem.isMarkedForDelete) {
                finalList.push(localItem);
            }
        }
    });

    for (let i = finalList.length - 1; i >= 0; i--) {
        if (finalList[i]?.isMarkedForDelete == true || finalList[i]?.isMarkedForDelete == 1) {
            finalList.splice(i, 1);
        }
    }

    // CLEANUP: remove isMarkedForDelete + convert aller/retour booleans to numbers
    const cleanedList = finalList.map(item => {
        const { isMarkedForDelete, ...rest } = item;

        // Convert aller and retour to number if boolean
        ['aller', 'retour'].forEach(key => {
            if (rest[key] !== undefined) {
                if (typeof rest[key] === 'boolean') {
                    rest[key] = rest[key] ? 1 : 0;
                }
            }
        });

        return rest;
    });

    return cleanedList;
}



function mergeTourCodes(existingValues = [], localValues = [], defaultTourCode) {
    let finalList = [...existingValues];

    localValues.forEach((localItem, index) => {
        const exists = index < existingValues.length;

        if (exists) {
            const existingItem = existingValues[index];

            // Determine modification (compare with DEFAULT)
            const isModified = Object.keys(defaultTourCode).some(
                key => localItem[key] !== undefined && localItem[key] !== defaultTourCode[key]
            );

            if (!isModified) {
                // No change → keep existing
                finalList[index] = existingItem;
                return;
            }

            // HANDLE passengerType updates (add/remove pax)
            let updatedPassengerType = existingItem.passengerType ? [...existingItem.passengerType] : [];

            if (Array.isArray(localItem.passengerType)) {
                updatedPassengerType = localItem.passengerType;
            }

            // If passengerType becomes empty but tourCodes unchanged → keep existing
            if (
                updatedPassengerType.length === 0 &&
                localItem.tourCodes === existingItem.tourCodes
            ) {
                finalList[index] = existingItem;
                return;
            }

            // Prepare updated row
            const updatedRow = {
                ...existingItem,
                ...localItem,
                passengerType: updatedPassengerType
            };

            finalList[index] = updatedRow;

        } else {
            // ADD new row
            if (!localItem.isMarkedForDelete) {
                finalList.push(localItem);
            }
        }
    });

    for (let i = finalList.length - 1; i >= 0; i--) {
        if (finalList[i]?.isMarkedForDelete === true) {
            finalList.splice(i, 1);
        }
    }

    return finalList;
}





function expandTourCodes(rawList = []) {
    return rawList.flatMap(item => {
        const paxArray = Array.isArray(item.passengerType)
            ? item.passengerType
            : item.passengerType ? [item.passengerType] : [];

        if (!item.tourCodes || item.tourCodes.trim() === "") {
            return [];
        }

        return paxArray.map(type => ({
            tourCodes: item.tourCodes,
            marketCode: item.marketCode,
            passengerType: type
        }));
    });
}

function deleteTourCodeRow(index, list, setList) {
    const updated = [...list];
    updated[index] = {
        ...updated[index],
        tourCodes: "",
        marketCode: "",
        passengerType: [],
        isMarkedForDelete: true
    };
    setList(updated);
}





//   let reverseBlackoutpayload = reverseBlackOutCarrierPayload(blackoutpayload);
//   console.log("=>>mainPayload", checkBoxObject?.blackOutCarrier)
//   console.log("=>>createBlackOutCarrierPayload", nestedPayload)
//   console.log("=>>reverseBlackOutCarrierPayload", reverseBlackoutpayload)


    const CheckBoxTypeSelector = ({checkBoxTypes, mainLabel, setMethod, useStateVariable=[], bulkEmpty=false, bulkEmptyFieldName="", handleBulkEmpty, bulkEmptyValue}) => {
        // Function to handle checkbox changes
        const handleCheckboxChange = (e, cabinType) => {
            if (useStateVariable.includes(cabinType)) {
                // If already selected, remove from the array
                setMethod(useStateVariable.filter((type) => type !== cabinType));
            } else {
                // If not selected, add to the array
                setMethod([...useStateVariable, cabinType]);
            }
        };

        const handleCheckbox = () => {
            handleBulkEmpty(bulkEmptyFieldName);
        }


        return (
            <div className={mainLabel == "Cabin Type" ? "col-md-6" : "col-md-3 cm-col"}>

                {bulkEmpty ? 
                    <div className="bulkEmptyLabel">
                        <label className="cm-head-label">{mainLabel}</label>
                        <Checkbox
                            color="primary"
                            checked={bulkEmptyValue[bulkEmptyFieldName]}
                            onChange={() => handleCheckbox(bulkEmptyFieldName)}
                        />
                    </div>
                :
                    <label className="cm-head-label">{mainLabel}</label>
                }

                <div className="row">
                    {checkBoxTypes.map((checkBox, index) => (
                        <div key={index} className="col-md-6">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        checked={useStateVariable.includes(checkBoxMappings[checkBox])}
                                        onChange={(e) => handleCheckboxChange(e,checkBoxMappings[checkBox])}
                                        disabled={(bulkEmpty && bulkEmptyValue[bulkEmptyFieldName]) ? true : mainLabel == "Cabin Type" ? useStateVariable?.length ? businessCabin.includes(useStateVariable[0]) ? economyCabin.includes(checkBoxMappings[checkBox]) : businessCabin?.includes(checkBoxMappings[checkBox]) : false : false}
                                    />
                                }
                                label={checkBox}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    const saveHandle = async () => {
        let tarifData = {
            "origins" : origins != "" ? origins.split(",").map(function (value) {return value.trim();}) : undefined,
            "destinations" : destinations != "" ? destinations.split(",").map(function (value) {return value.trim();}) : undefined,
            "marketingAirline" : bulkEmpty?.marketingAirline ? [null] : marketingAirline != "" ? marketingAirline.split(",").map(function (value) {return value.trim();}) : undefined,
            "mappedOpeartingAirlines" : bulkEmpty?.operatingAirline ? [null] : mappedOpeartingAirlines != "" ? mappedOpeartingAirlines.split(",").map(function (value) {return value.trim();}) : undefined,
            "maximumFeeCCBycarrierType" : maximumFeeCCBycarrierType != "" ? maximumFeeCCBycarrierType : undefined,
            "maximumFeeCCAmoutByCarrier" : checkForEmptyAndConvertToNumber(maximumFeeCCAmoutByCarrier) ,
            "note" : note != "" ? note : undefined,
            "ccFeesForTBMerchant" : checkForEmptyAndConvertToNumber(ccFeesForTBMerchant) ,
            "landFare" : landFare ? landFare : landFare == null ? undefined : 0,
            "cruiseFare" : cruiseFare ? cruiseFare : cruiseFare == null ? undefined : 0,
            "cabinType" : cabinType?.length ? cabinType : undefined,
            "tripType" : tripType != "" ? tripType : undefined,
            "isBrandedFare" : isBrandedFare != "" ? isBrandedFare : undefined,
            "DFW": bulkEmpty?.distribution ? null : distribution.includes('DFW') ? true : undefined,
            "funSun" : bulkEmpty?.distribution ? null : distribution.includes('Fun Sun') ? true : undefined,
            "intairTransit" : bulkEmpty?.distribution ? null : distribution.includes('Intair Transit') ? true : undefined,
            "skyLink" : bulkEmpty?.distribution ? null : distribution.includes('Sky Link') ? true : undefined,
            "sunquest" : bulkEmpty?.distribution ? null : distribution.includes('Sunquest') ? true : undefined,
            "network" : bulkEmpty?.distribution ? null : distribution.includes('Network') ? true : undefined,
            "formsOfPayment" : formsOfPayment?.length ? formsOfPayment : undefined,
            "disallowedAirports" : bulkEmpty?.airportNotAllowed ? null : disallowedAirports?.length ? disallowedAirports : undefined,
            "isDisabled" : tariffDisabled !== "" ? tariffDisabled : undefined,
            "contractOwner": tariffOwner != "" ? tariffOwner : undefined,
            "pseudoCityCodes": bulkEmpty?.PCCDuTariff ? "" : old_tarfPCC_VIT != "" ? old_tarfPCC_VIT : undefined,
            "tarifPCC_FUN": bulkEmpty?.PCCDuTariff ? "" : tarifPCC_FUN != "" ? tarifPCC_FUN : undefined,
            "tarifPCC_SKY": bulkEmpty?.PCCDuTariff ? "" : tarifPCC_SKY != "" ? tarifPCC_SKY : undefined,
            "tarifPCC_TC": bulkEmpty?.PCCDuTariff ? "" : tarifPCC_TC != "" ? tarifPCC_TC : undefined,
            "tarifPCC_DFW": bulkEmpty?.PCCDuTariff ? "" : tarifPCC_DFW != "" ? tarifPCC_DFW : undefined,
            "skipRoutingCheck": skipRoutingCheck !== "" ? skipRoutingCheck : undefined,
            "distributionChannels": bulkEmpty?.cannotBeDistributed ? [] : distributionChannels?.length ? distributionChannels : undefined,
            "calculationBasis": calculationBasis != "" ? calculationBasis : undefined,
        }

        const accountCodePayload = (() => {
            if (bulkEmpty?.accountCode) {
                return { "DFW": "", "FUN": "", "SKY": "", "TC": "", "VIT": "" };
            }
            const payload = {};
            if (accountCodeDFW !== "") payload.DFW = accountCodeDFW;
            if (accountCodeFUN !== "") payload.FUN = accountCodeFUN;
            if (accountCodeSKY !== "") payload.SKY = accountCodeSKY;
            if (accountCodeTC !== "") payload.TC = accountCodeTC;
            if (accountCodeVIT !== "") payload.VIT = accountCodeVIT;
            return Object.keys(payload).length ? payload : undefined;
        })();

        let classData = {
            "brandCode":brandCode != "" ? brandCode : undefined,
            "classCodes": classCodes != "" ? classCodes.split(",").map(function (value) {return value.trim();}) : undefined,
            "category": category != "" ? category : undefined,
            "contractType": contractType != "" ? contractType : undefined,
            "ticketingFee": checkForEmptyAndConvertToNumber(ticketingFee) ,
            "classNote": classNote != "" ? classNote : undefined,
            "minmaxStay": minmaxStay != "" ? minmaxStay : undefined,
            "classLastTicketingDate": classLastTicketingDate ? classLastTicketingDate : undefined,
            "ageRestrictions" :(ageRestrictionsChildAge || ageRestrictionsInfantAge || ageRestrictionsInfantAgeApplicableOn) ? {"childAge":ageRestrictionsChildAge != "" ? Number(ageRestrictionsChildAge) : undefined,"infantAge": ageRestrictionsInfantAge != "" ? Number(ageRestrictionsInfantAge) : undefined,"infantAgeApplicableOn": ageRestrictionsInfantAgeApplicableOn != "" ? ageRestrictionsInfantAgeApplicableOn : undefined, "noTicketingForInfant":false} : undefined, 
            "juniorAgeFrom": juniorAgeFrom ? juniorAgeFrom : undefined,
            "juniorAgeTo" : juniorAgeTo ? juniorAgeTo : undefined,
            "osi" : bulkEmpty?.OSI ? "" : osi != "" ? osi : undefined,
            "permitBranchPNR" : bulkEmpty?.branchFiles ? null : permitBranchPNR ? permitBranchPNR : undefined,
            "ticketingRules": (!emptyArrayOfObjects(optionDates) || !emptyArrayOfObjects(ticketDates)) ? {
                "optionDates": !emptyArrayOfObjects(optionDates) ? normalizeTicketingDateEntries(optionDates) : null,
                "ticketDates": !emptyArrayOfObjects(ticketDates) ? normalizeTicketingDateEntries(ticketDates) : null
            } : undefined,
            "classRoutings" : classRoutings != "" ? classRoutings : undefined,
            "disableAutoTicketing" : disableAutoTicketing !=null ? disableAutoTicketing : undefined,
            "disablePriceUnitConcept" : disablePriceUnitConcept !=null ? disablePriceUnitConcept : undefined,
            "issueAsBulk" : bulkEmpty?.issueAsBulk ? null : issueAsBulk ? issueAsBulk : undefined,
            "fareType" : fareType != "" ? fareType : undefined,
            ...(accountCodePayload !== undefined ? { "accountCode": accountCodePayload } : {}),
            "ticketDesignator": bulkEmpty?.ticketDesignator ? { "DFW": "", "FUN": "", "SKY": "", "TC": "", "VIT": "" } : (ticketDesignatorVIT || ticketDesignatorSKY || ticketDesignatorDFW || ticketDesignatorTC || ticketDesignatorFUN) ? { "DFW": ticketDesignatorDFW != "" ? ticketDesignatorDFW : undefined, "FUN": ticketDesignatorFUN != "" ? ticketDesignatorFUN : undefined, "SKY": ticketDesignatorSKY != "" ? ticketDesignatorSKY : undefined, "TC": ticketDesignatorTC != "" ? ticketDesignatorTC : undefined, "VIT": ticketDesignatorVIT != "" ? ticketDesignatorVIT : undefined } : undefined,
            "remarks" : (remarksVITFR || remarksVITENG || remarksTCFR || remarksTCENG || remarksSKYFR || remarksSKYENG || remarksFUNFR || remarksFUNENG || remarksDFWFR || remarksDFWENG ) ? {"DFW":{"english":remarksDFWENG != "" ? remarksDFWENG : undefined,"french":remarksDFWFR != "" ? remarksDFWFR : undefined},"FUN":{"english":remarksFUNENG != "" ? remarksFUNENG : undefined,"french":remarksFUNFR != "" ? remarksFUNFR : undefined},"SKY":{"english":remarksSKYENG != "" ? remarksSKYENG : undefined,"french":remarksSKYFR != "" ? remarksSKYFR : undefined },"TC":{"english":remarksTCENG != "" ? remarksTCENG : undefined,"french":remarksTCFR != "" ? remarksTCFR : undefined},"VIT":{"english":remarksVITENG != "" ? remarksVITENG : undefined,"french":remarksVITFR != "" ? remarksVITFR : undefined }} : undefined,
            "classCodeDesc": classCodeDescription != "" ? classCodeDescription : undefined,
        }
        let newTourCode = {}
        if ((!emptyArrayOfObjects(tourCodeRepetative))) {
            if (tourCodeRepetative?.length > 0) {
                const output = tourCodeRepetative.flatMap(item =>
                    item?.passengerType?.flatMap(type => {
                        // Skip this object if tourCodes is an empty string
                        if (item?.tourCodes === "") return [];
                        return {
                            tourCodes: item?.tourCodes,
                            marketCode: item?.marketCode,
                            passengerType: type
                        };
                    })
                );
                newTourCode = output;
            }
        }
        const resultBlackoutDates = mergeValues(existingBlackoutDates, blackoutDatesRepetative, blackoutDate);
        const resultBlackoutDays = mergeValues(existingBlackoutDays, blackoutDaysRepetative, blackoutDay);
        const mergedRawTourCodes = mergeTourCodes(existingTourCodes, tourCodeRepetative, tourCode);
        const resultTourCodes = expandTourCodes(mergedRawTourCodes);
        console.log("yoo>>--", resultBlackoutDates, resultBlackoutDays, resultTourCodes, newTourCode);
        
        // Helper function to format commission values with regex check
        const formatCommissionValue = (value) => {
            if (value === undefined || value === null) return undefined;
            const normalizedValue = `${value}`.trim();
            if (normalizedValue === "") return undefined;
            const hasPercentageOrDollar = /[%$]$/.test(normalizedValue);
            return hasPercentageOrDollar ? normalizedValue : `${normalizedValue}%`;
        };

        let prixData ={
            "validFrom" : validFrom ? validFrom : undefined,
            "validTo" : validTo ? validTo : undefined,
            "prixLastReturnDate" : bulkEmpty?.lastReturnDate ? null : prixLastReturnDate ? prixLastReturnDate : undefined,
            "prixLastTicketingDate" : bulkEmpty?.lastTicketingDate ? null : prixLastTicketingDate ? prixLastTicketingDate : undefined,
            "prixNote" : prixNote != "" ? prixNote : undefined,
            "commissionPercentage": commissionPercentage != "" ? (commissionPercentage?.charAt(0) !== '+' && commissionPercentage?.charAt(0) !== '-') ? '-' + commissionPercentage : commissionPercentage : undefined,
            "childCommissionPercentage": childCommissionPercentage != "" ? (childCommissionPercentage?.charAt(0) !== '+' && childCommissionPercentage?.charAt(0) !== '-') ? '-' + childCommissionPercentage : childCommissionPercentage : undefined,
            "infantCommissionPercentage": infantCommissionPercentage != "" ? (infantCommissionPercentage?.charAt(0) !== '+' && infantCommissionPercentage?.charAt(0) !== '-') ? '-' + infantCommissionPercentage : infantCommissionPercentage : undefined,
            "passBackCommission": passBackCommission != "" ? passBackCommission : undefined,
            "childPassBackCommission": childPassBackCommission != "" ? childPassBackCommission : undefined,
            "infantPassBackCommission": infantPassBackCommission != "" ? infantPassBackCommission : undefined,

            "adultCommissionOnYQ" : formatCommissionValue(adultCommissionOnYQ),
            "childCommissionOnYQ" : formatCommissionValue(childCommissionOnYQ),
            "enfantCommissionOnYQ" : formatCommissionValue(enfantCommissionOnYQ),
            "markup" : markup != "" ? markup : undefined,
            "childMarkUp" : childMarkup != "" ? childMarkup : undefined,
            "infantMarkUp" : infantMarkUp != "" ? infantMarkUp : undefined,
            "adultPassBackCommissionOnYQ" : formatCommissionValue(adultPassBackCommissionOnYQ),
            "childPassBackCommissionOnYQ" : formatCommissionValue(childPassBackCommissionOnYQ),
            "enfantPassBackCommissionOnYQ" : formatCommissionValue(enfantPassBackCommissionOnYQ),
            "adultCommissionOnYQNav" : formatCommissionValue(adultCommissionOnYQNav),
            "childCommissionOnYQNav" : formatCommissionValue(childCommissionOnYQNav),
            "enfantCommissionOnYQNav" : formatCommissionValue(enfantCommissionOnYQNav),
            "adultPassBackCommissionOnYQNav" : formatCommissionValue(adultPassBackCommissionOnYQNav),
            "childPassBackCommissionOnYQNav" : formatCommissionValue(childPassBackCommissionOnYQNav),
            "enfantPassBackCommissionOnYQNav" : formatCommissionValue(enfantPassBackCommissionOnYQNav),
            "blackOutDates" : emptyArrayOfObjects(blackoutDatesRepetative) ? undefined : resultBlackoutDates,
            "blackOutDays" : emptyArrayOfObjects(blackoutDaysRepetative) ? undefined : resultBlackoutDays,
            "blackOutCarrier" : emptyArrayOfObjects(blackoutAirlinesRepetative) ? undefined : reverseBlackOutCarrierPayload(nestedPayload),
            "endorsement" : bulkEmpty?.endorsement ? { "TC": "", "DFW": "", "FUN": "", "SKY": "", "VIT": "" } : (endorsementTC || endorsementFUN || endorsementDFW || endorsementSKY || endorsementVIT) ? {"TC": endorsementTC != "" ? endorsementTC : undefined,"DFW": endorsementDFW != "" ? endorsementDFW : undefined,"FUN": endorsementFUN != "" ? endorsementFUN : undefined,"SKY": endorsementSKY != "" ? endorsementSKY : undefined,"VIT": endorsementVIT != "" ? endorsementVIT : undefined} : undefined,
            "tourCode" : emptyArrayOfObjects(tourCodeRepetative) ? undefined : resultTourCodes?.length > 0 ? resultTourCodes : undefined,
            "minumumSellingPrice": minumumSellingPrice != "" ? minumumSellingPrice : undefined,
        }

        tarifData = stripUndefinedValues(tarifData);
        classData = stripUndefinedValues(classData);
        prixData = stripUndefinedValues(prixData);
        const payload = {
            "tarifKeys": (checkBoxObject?.tarifs?.length && !emptyObject(tarifData)) ? checkBoxObject?.tarifs : undefined,
            "tarifData" : (checkBoxObject?.tarifs?.length && !emptyObject(tarifData)) ? tarifData : undefined,
            "classKeys": (checkBoxObject?.classes?.length && !emptyObject(classData)) ? checkBoxObject?.classes : undefined,
            "classData" : (checkBoxObject?.classes?.length && !emptyObject(classData)) ? classData: undefined,
            "prixKeys" : (checkBoxObject?.prixs?.length && !emptyObject(prixData)) ? checkBoxObject?.prixs : undefined,
            "prixData" : (checkBoxObject?.prixs?.length && !emptyObject(prixData)) ? prixData : undefined
        }

        const formatField = Object.keys(formatFields).filter((field) => formatFields[field]);

        if (formatField.length > 0) {
            
            swal({
                text: "Please fill all the fields in proper format.",
                icon: "error",
                button: "Close",
                timer: 2000,
            })
            return;
        }

        const bulkUpdateResponse = await putBulkUpdate(payload)
        if(bulkUpdateResponse?.message != "Bulk update was successful"){
            // swal({
            //   text:bulkUpdateResponse?.message,
            //   icon: "error",
            //   button: "Close",
            //   timer: 2000,
            // })
            showDetailedErrorSwal({
                message: bulkUpdateResponse?.message,
                errorDetails: bulkUpdateResponse?.errorDetails
            });
        }else{
            swal({
                text:bulkUpdateResponse?.message,
                icon: "success",
                button: "Close",
                timer: 2000,
              })
              dispatch(setSearchAllV2([]))
              history.push(`/Newcontractlist`)
        }
    }

    const emptyObject = (data) => {
        let allFildsAreEmpty = true;
        Object.keys(data).map((key) => {
            if (data[key] !== undefined) {
                allFildsAreEmpty = false;
            }
        })
        return allFildsAreEmpty
    }

    const isEmptyValue = (value) => {
        if (value === null || value === undefined) return true;
        if (typeof value === "string") return value.trim() === "";
        if (Array.isArray(value)) return value.length === 0;
        if (typeof value === "object") return Object.keys(value).length === 0;
        if (typeof value === "boolean") return value === false;
        return false; // numbers, true, non-empty values
    };

    const emptyArrayOfObjects = (data) => {
        let allFieldsAreEmpty = true;

        for (let i = 0; i < data.length; i++) {
            for (const key in data[i]) {
                if (!isEmptyValue(data[i][key])) {
                    allFieldsAreEmpty = false;
                    break;
                }
            }
            if (!allFieldsAreEmpty) break;
        }
        return allFieldsAreEmpty;
    };
      

    const stripUndefinedValues = (data) => {
        if (!data || typeof data !== 'object' || Array.isArray(data)) {
            return data;
        }
        Object.keys(data).forEach((key) => {
            const value = data[key];
            // Preserve ticketingRules structure to prevent deletion of optionDates or ticketDates
            if (key === 'ticketingRules' && value && typeof value === 'object' && !Array.isArray(value)) {
                // Don't strip null/undefined values from ticketingRules to preserve both fields
                // This ensures that when updating one field, the other field is preserved on the backend
                return;
            }
            if (value === undefined) {
                delete data[key];
                return;
            }
            if (value && typeof value === 'object' && !Array.isArray(value)) {
                stripUndefinedValues(value);
                if (!Object.keys(value).length) {
                    delete data[key];
                }
            }
        });
        return data;
    }

    const originDestinationValidtion = (length) => {
        if(length > 3){
            swal({
                text:"Only three characters accepted",
                icon: "error",
                button: "Close",
                timer: 2000,
              })
            return false
        }
        return true
    }

    const specialCharacterCheck = (data) => {
        return /[-’/`~!#*$@_%+=.^&(){}[\]|;:”<>?\\]/g.test(data)
    }

    const numericalCharacterCheck = (data) => {
        return /[0-9]/g.test(data)
    }

    const checkECharacter = (value) => {
       return !(String(value).toUpperCase()).includes('E')
    }

    const checkForEmptyAndConvertToNumber = (data) =>{
        if(data) return Number(data)
    }

    const addToArrayProperty = (obj, prop, value) => {
        if (Array.isArray(obj?.[prop])) {
            obj[prop].push(value);
        } else {
            obj[prop] = [value];
        }
        return obj[prop]
    }

    const removeItem = (array, indexToRemove) => {
        return array.filter((item, index) => index !== indexToRemove);
    };

    const changeOptionTicket = (e, type, index) => {
        
        if (type == "option") {
            let data = [...optionDates];
            let optionData = data[index];
            let name = e.target.name;
            let value = e.target.value.toUpperCase();
            optionData[name] = value;
            data[index] = optionData
            setOptionDates(data)
        } else if (type == "ticket") {
            let data = [...ticketDates];
            let optionData = data[index];
            let name = e.target.name;
            let value = e.target.value.toUpperCase();
            optionData[name] = value;
            data[index] = optionData;
            setTicketDates(data)
        }
        
    }

    const handleAddTicketDate = () => {
        let data = [...ticketDates];
        data.push({
            departureWindow: '',
            daysAfterReservation: '',
            daysBeforeDeparture: ''
        });
        setTicketDates(data);
    };

    const handleRemoveTicketDate = (index) => {
        const updatedTicketDates = [...ticketDates];
        updatedTicketDates.splice(index, 1);
        setTicketDates(updatedTicketDates);
    };

    const handleAddOptionDate = () => {
        let data = [...optionDates];
        data.push({
            departureWindow: '',
            daysAfterReservation: '',
            daysBeforeDeparture: ''
        });
        setOptionDates(data);
    };

    const handleRemoveOptionDate = (index) => {
        const updatedOptionDates = [...optionDates];
        updatedOptionDates.splice(index, 1);
        setOptionDates(updatedOptionDates);
    };

    return (
        <>
             <div className="cm-head-2 mb-8">
                    <div className="d-flex justify-content-between">
                        <span className="cm__Title">Bulk Edit</span>
                        <span></span>
                    </div>
                </div>
            <div className="card cm-card">
                <div className="card-body">
                    {/* >>>>>>>>>>>>>>>>>>>>> tariff Search >>>>>>>>>>>>>>>>>>>>>. */}
                    {checkBoxObject?.tarifs?.length ?
                    <>
                    <div className="cm-head-2 cm-col">
                        <div className="d-flex justify-content-between">
                            <span className="">Tariff </span>
                            <div className="cm-head-checkbox d-flex">
                            </div>
                        </div>
                    </div>
                    <div>
                        {/* ORIGIN AND DESTINATION SEARCH SECTION */}
                        <div className="row">
                            <div className="col-md-6 cm-col">
                                <div className="row">
                                    {/* <div className="col-md-6">
                                        <label className="cm-head-label">Origin</label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Origin"
                                            value={origins}
                                            onChange={(e) => {!specialCharacterCheck(String(e?.target?.value).toUpperCase()) && originDestinationValidtion(e?.target?.value.length) && setOrigins(String(e?.target?.value).toUpperCase())}}
                                        />
                                    </div> */}
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Validating Carrier</label>
                                        <input label='Validating Carrier'
                                            className="form-control cm-input autoCapitalise custom-disabled-field "
                                            disabled={(true)}
                                        />
                                    </div>

                                    <div className="col-md-6">
                                        <label className="cm-head-label">Origin</label>
                                        <input label='Validating Carrier'
                                            className="form-control cm-input autoCapitalise custom-disabled-field "
                                            disabled={(true)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 cm-col">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Destination</label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Destination"
                                            value={destinations}
                                            onChange={(e) => { !specialCharacterCheck(String(e?.target?.value).toUpperCase()) && setDestinations(String(e?.target?.value).toUpperCase()) }}
                                        />
                                    </div>
                                    
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Trip Type </label>
                                        <div className="cm-radio-inline custom-disabled-field">
                                            <FormControlLabel control={<Radio color="primary" disabled={(true)} />} label="One Way"
                                            />
                                            <FormControlLabel control={<Radio color="primary" disabled={(true)} />} label="Not One Way"
                                            />{" "}
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='row cm-col'>
                            <div className="col-md-6">
                                <div className="row">
                                    <CheckBoxTypeSelector checkBoxTypes={[
                                        'Economy',
                                        'Premium Economy',
                                        'Business',
                                        'First',
                                    ]} mainLabel={"Cabin Type"} setMethod={setCabinType} useStateVariable={cabinType} />

                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Branded Fare</label>
                                        <div className="cm-radio-inline custom-disabled-field">
                                            <FormControlLabel control={<Radio color="primary" disabled={(true)} />} label="Yes" />
                                            <FormControlLabel control={<Radio color="primary" disabled={(true)} />} label="No" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="col-md-6">

                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Contract Type</label>
                                        <div className="cm-checkbox-inline custom-disabled-field">
                                            <FormControlLabel control={<Checkbox color="primary" checked={Boolean(landFare)} onChange={(e) => { if (e.target.checked) { setLandFare(1); setCruiseFare(0) } }} />} label="Land" />
                                            <FormControlLabel control={<Checkbox color="primary" checked={landFare != null && cruiseFare != null && !Boolean(landFare) && !Boolean(cruiseFare)} onChange={(e) => { if (e.target.checked) { setLandFare(0); setCruiseFare(0); } }} />} label="Air Only" />
                                            <FormControlLabel control={<Checkbox color="primary" checked={Boolean(cruiseFare)} onChange={(e) => { if (e.target.checked) { setCruiseFare(1); setLandFare(0) } }} />} label="Cruise" />
                                        </div>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Tariff Disabled </label>
                                        <div className="cm-radio-inline custom-disabled-field">
                                            <FormControlLabel control={<Radio color="primary" checked={tariffDisabled} onClick={() => (tariffDisabled == true) ? setTariffDisabled("") : setTariffDisabled(true)} />} label="Yes" />
                                            <FormControlLabel control={<Radio color="primary" checked={(tariffDisabled === false)} onClick={() => (tariffDisabled === false) ? setTariffDisabled("") : setTariffDisabled(false)} />} label="No" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row cm-col">
                            
                            <div className="col-md-3 cm-col">
                                {/* <div className="col-md-9 cm-col"> */}
                                    <div className="bulkEmptyLabel">
                                        <label className="cm-head-label">Marketing Airlines</label>
                                        <Checkbox color="primary" checked={bulkEmpty?.marketingAirline} onChange={() => handleBulkEdit("marketingAirline")} />
                                    </div>
                                    <input
                                        className="form-control cm-input"
                                        placeholder="Enter Marketing Airlines"
                                        value={marketingAirline}
                                        disabled={bulkEmpty?.marketingAirline}
                                        onChange={(e) => !specialCharacterCheck(String(e?.target?.value).toUpperCase()) && setMarketingAirline(String(e?.target?.value).toUpperCase())}
                                    />
                                {/* </div> */}
                            </div>

                                <div className="col-md-3 cm-col">
                                    {/* <div className="col-md-9 cm-col"> */}
                                        <div className="bulkEmptyLabel">
                                            <label className="cm-head-label">Operating Airlines</label>
                                            <Checkbox color="primary" checked={bulkEmpty?.operatingAirline} onChange={() => handleBulkEdit("operatingAirline")} />
                                        </div>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Operating Airlines"
                                            value={mappedOpeartingAirlines}
                                            disabled={bulkEmpty?.operatingAirline}
                                            onChange={(e) => !specialCharacterCheck(String(e?.target?.value).toUpperCase()) && setMappedOpeartingAirlines(String(e?.target?.value).toUpperCase())}
                                        />
                                    {/* </div> */}
                                </div>

                                <div className="col-md-3 cm-col">
                                    {/* <div className="col-md-9 cm-col"> */}
                                        <label className="cm-head-label">Tariff Note</label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Tariff Note"
                                            value={note}
                                            onChange={(e) => setNote(e?.target?.value.toUpperCase())}
                                        />
                                    {/* </div> */}

                                </div>

                                <div className="col-md-3 cm-col">
                                    {/* <div className="col-md-9 cm-col"> */}
                                        <label className="cm-head-label">Contract Owner</label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Contract Owner"
                                            value={tariffOwner}
                                            onChange={(e) => setTariffOwner(e?.target?.value?.toUpperCase())}
                                            maxLength={20}
                                        />
                                    {/* </div> */}

                                </div>

                                
                        </div>

                        <div className="cm-head-2 cm-col">
                            <div className="d-flex justify-content-between">
                                <span className="">Characteristics </span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>
                        <div className="row cm-col">
                            <CheckBoxTypeSelector checkBoxTypes={[
                                'Cheque',
                                'Credit Card',
                                'Credit Internal'
                            ]} mainLabel={<label className="cm-head-label">FOP allowed (by Airline) for <br />Ticket issuance</label>} setMethod={setFormsOfPayment} useStateVariable={formsOfPayment} />

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Maximum Authorised Amount on<br /> Airline as Merchant </label>
                                <div className="row">
                                    <div className="col-md-4 cm-col">
                                        <div className="cm-radio-inline ml-0">
                                            <FormControlLabel control={<Radio color="primary" checked={maximumFeeCCBycarrierType == 'Amount'} onClick={()=>maximumFeeCCBycarrierType == 'Amount'? setMaximumFeeCCBycarrierType(""):setMaximumFeeCCBycarrierType('Amount')}/>} label="($)"
                                            />
                                            <FormControlLabel control={<Radio color="primary" checked={maximumFeeCCBycarrierType == 'Percentage'} onClick={()=>maximumFeeCCBycarrierType == 'Percentage'?setMaximumFeeCCBycarrierType(''):setMaximumFeeCCBycarrierType('Percentage')}/>} label="(%)"
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-8 cm-col">
                                        <div className="cm-radio-inline">
                                            <input
                                                className="form-control cm-input"
                                                placeholder="Enter Amount"
                                                type='number'
                                                value={maximumFeeCCAmoutByCarrier}
                                                onChange={(e) => checkECharacter(e?.target?.value) && setMaximumFeeCCAmoutByCarrier(e?.target?.value)}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Combination</label>
                                <div className="cm-radio-inline">
                                        <FormControlLabel className='mr-2' control={<Radio color="primary" checked={calculationBasis == "AVERAGE"} onClick={() => { calculationBasis == "AVERAGE" ? setCalculationBasis("") : setCalculationBasis("AVERAGE") }} />} label="Average" />
                                        <FormControlLabel className='mr-0' control={<Radio color="primary" checked={calculationBasis == "MINIMUM"} onClick={() => { calculationBasis == "MINIMUM" ? setCalculationBasis("") : setCalculationBasis("MINIMUM") }} />} label="Minimum" />
                                        <FormControlLabel className='mr-2' control={<Radio color="primary" checked={calculationBasis == "MAXIMUM"} onClick={() => { calculationBasis == "MAXIMUM" ? setCalculationBasis("") : setCalculationBasis("MAXIMUM") }} />} label="Maximum" />
                                </div>
                            </div>
                            
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Credit Card Processing Fees</label>
                                <div className="row">
                                    <div className="col-md-9 cm-col">
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Fees"
                                            type='number'
                                            value={ccFeesForTBMerchant}
                                            onChange={(e) => checkECharacter(e?.target?.value) && setCcFeesForTBMerchant(e?.target?.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                        </div>

                        <div className="cm-head-2 cm-col">
                            <div className="d-flex justify-content-between">
                                <span className="">Routings </span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>
                        <div className="row cm-col">
                            <div className="col-md-3">
                                <div className="cm-col">
                                    <div className="bulkEmptyLabel">
                                        <label className="cm-head-label">Airport not allowed</label>
                                        <Checkbox color="primary" checked={bulkEmpty?.airportNotAllowed} onChange={() => handleBulkEdit("airportNotAllowed")} />
                                    </div>
                                    <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.airportNotAllowed} value={disallowedAirports?.join()} onChange={(e)=>setDisallowedAirports([e.target.value?.toUpperCase()])} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="cm-col mt-1 custom-disabled-field">
                                    <label className="cm-head-label"></label>
                                    <FormControlLabel control={<Checkbox color="primary" checked={skipRoutingCheck} />} label="No Routing Validation By Startrek" onChange={() => setSkipRoutingCheck(!(skipRoutingCheck))} />
                                </div>
                            </div>
                        </div>
                        

                        <div className="cm-head-2 cm-col">
                            <div className="d-flex justify-content-between">
                                <span className="">Distribution </span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>
                        <div className="row">

                            
                            {/* <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Trip Type</label>
                                <div className="cm-radio-inline">
                                    
                                    <FormControlLabel control={<Radio color="primary" checked={tripType === "OW" ? true : false} onChange={(e) => setTripType("OW")} />} label="One Way"
                                    />
                                    <FormControlLabel control={<Radio color="primary" checked={tripType === "-OW" ? true : false} onChange={(e) => setTripType("-OW")} />} label="Not One Way"
                                    />{" "}
                                </div>
                                <label className="cm-head-label mt-3">Branded Fare</label>
                                <div className="cm-radio-inline">
                                    <FormControlLabel control={<Radio color="primary" checked={isBrandedFare == "1" ? true : false} onChange={(e) => {if(e?.target?.checked){ setIsBrandedFare("1")}}} />} label="Yes"
                                    />
                                    <FormControlLabel control={<Radio color="primary" checked={isBrandedFare == "0" ? true : false} onChange={(e) => {if(e?.target?.checked){ setIsBrandedFare("0")}}} />} label="No"
                                    />{" "}
                                </div>
                            </div> */}
                                <CheckBoxTypeSelector checkBoxTypes={[
                                'Sky Link',
                                'Intair Transit',
                                'Fun Sun',
                                'DFW',
                                'Sunquest',
                                'Network'
                            ]} mainLabel={"Distribution"} useStateVariable={distribution} setMethod={setDistribution} bulkEmpty={true} bulkEmptyFieldName={"distribution"} handleBulkEmpty={handleBulkEdit} bulkEmptyValue={bulkEmpty}/>
                            
                            

                            <div className="col-md-3">
                                <div className="cm-col custom-disabled-field">
                                    <div className="bulkEmptyLabel">
                                        <label className="cm-head-label">Can not be distributed</label>
                                        <Checkbox color="primary" checked={bulkEmpty?.cannotBeDistributed} onChange={() => handleBulkEdit("cannotBeDistributed")} />
                                    </div>
                                        <FormControlLabel control={<Checkbox color="primary"
                                            checked={distributionChannels && distributionChannels.includes("INTERNAL")} disabled={bulkEmpty?.cannotBeDistributed}/>}
                                            label="Internal Users"
                                                onChange={(e) => {
                                                    if (distributionChannels?.includes("INTERNAL")) {
                                                        const updated = removeItem([...distributionChannels], distributionChannels.indexOf("INTERNAL"));
                                                        setDistributionChannels(updated);
                                                    } else {
                                                        const updated = [...(distributionChannels || []), "INTERNAL"];
                                                        setDistributionChannels(updated);
                                                    }
                                                }}
                                                disabled={bulkEmpty?.cannotBeDistributed}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox color="primary"
                                                checked={distributionChannels && distributionChannels.includes("EXTERNAL")} disabled={bulkEmpty?.cannotBeDistributed}/>}
                                            label="External Users"
                                            onChange={(e) => {
                                                    if (distributionChannels?.includes("EXTERNAL")) {
                                                        const updated = removeItem([...distributionChannels], distributionChannels.indexOf("EXTERNAL"));
                                                        setDistributionChannels(updated);
                                                    } else {
                                                        const updated = [...(distributionChannels || []), "EXTERNAL"];
                                                        setDistributionChannels(updated);
                                                    }
                                                }}
                                                disabled={bulkEmpty?.cannotBeDistributed}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox color="primary"
                                                checked={distributionChannels && distributionChannels.includes("XML-B2C")} disabled={bulkEmpty?.cannotBeDistributed}/>}
                                            label="XML - B2C"
                                            onChange={(e) => {
                                                if (distributionChannels?.includes("XML-B2C")) {
                                                    const updated = removeItem([...distributionChannels], distributionChannels.indexOf("XML-B2C"));
                                                    setDistributionChannels(updated);
                                                } else {
                                                    const updated = [...(distributionChannels || []), "XML-B2C"];
                                                    setDistributionChannels(updated);
                                                }
                                            }}
                                            disabled={bulkEmpty?.cannotBeDistributed}
                                        />
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">PCC DU TARIFF</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.PCCDuTariff} onChange={() => handleBulkEdit("PCCDuTariff")} />
                                </div>
                                <div className='row'>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">VIT</label>
                                        <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.PCCDuTariff} value={old_tarfPCC_VIT} onChange={(e) => setOld_tarfPCC_VIT(e?.target?.value?.toUpperCase())} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">FUN</label>
                                        <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.PCCDuTariff} value={tarifPCC_FUN} onChange={(e) => setTarifPCC_FUN(e?.target?.value?.toUpperCase())} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">SKY</label>
                                        <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.PCCDuTariff} value={tarifPCC_SKY} onChange={(e) => setTarifPCC_SKY(e?.target?.value?.toUpperCase())} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">TC</label>
                                        <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.PCCDuTariff} value={tarifPCC_TC} onChange={(e) => setTarifPCC_TC(e?.target?.value?.toUpperCase())} />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">DFW</label>
                                        <input className="form-control cm-input autoCapitalise" type="text" disabled={bulkEmpty?.PCCDuTariff} value={tarifPCC_DFW} onChange={(e) => setTarifPCC_DFW(e?.target?.value?.toUpperCase())} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    </>
                    :
                    null
                    }

                    {checkBoxObject?.classes?.length ?
                    <>
                    <div className="row headerCollap">
                        <div className="col-6">
                            <p className="headerTitle">Class</p>
                        </div>
                        <div className="col-6 text-right" >
                            <i className="fas fa-caret-up" aria-hidden="true"></i>
                        </div>
                    </div>

                    <div>
                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Carrier</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Origin</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />

                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Destination</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />

                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Trip Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Contract Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Fare Type</label>
                                <div className="cm-radio-inline">
                                    <FormControlLabel control={<Radio color="primary" checked={contractType === "Published" ? true : false} onClick={(e) => contractType === "Published" ? setContractType("") : setContractType("Published")} />} label="(%) Published"
                                    />
                                    <FormControlLabel control={<Radio color="primary" checked={contractType === "Net" ? true : false} onClick={(e) => contractType === "Net" ? setContractType("") : setContractType("Net")} />} label="($) Net"
                                    />
                                </div>
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Branded Fare</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                                
                            </div>

                            

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Cabin Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label"> Class of Service </label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Classe"
                                    value={classCodes}
                                    onChange={(e) => {
                                        let value = e.target.value?.toUpperCase();

                                        if (!specialCharacterCheck(value)) {
                                            // Run regex test
                                            const isInvalid = regex.test(value); // assuming regex is defined above
                                            setClassCodes(value);

                                            // Update your copyFormatFields (assuming it's in state or accessible)
                                            setFormatFields(prev => ({
                                                ...prev,
                                                classes: isInvalid ? false : true
                                            }));
                                        }
                                    }}
                                />

                                {formatFields?.classes &&
                                    <div className='bd-errorMsg mt-3'>Please enter valid class code.</div>
                                }
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Brand Code </label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Brand Id"
                                    value={brandCode}
                                    onChange={(e)=>{!specialCharacterCheck(String(e?.target?.value).toUpperCase()) && setBrandCode(String(e.target.value).toUpperCase())}}
                                    maxLength={15}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Class Note</label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter note"
                                    type="text"
                                    value={classNote}
                                    onChange={(e)=>{setClassNote(String(e.target.value?.toUpperCase()))}}
                                />
                            </div>
                            
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Class EDR Date</label>
                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className='BulkUpdate__DatePicker' value={classLastTicketingDate} onChange={(date) => { setClassLastTicketingDate(moment.utc(date).format("YYYY-MM-DD")) }} format="yyyy-MM-dd"/>
                                </MuiPickersUtilsProvider> */}
                                <CustomDateInput
                                    value={classLastTicketingDate}
                                    onChange={setClassLastTicketingDate}
                                    // label="Class EDR Date"
                                    className="BulkUpdate__DatePicker"
                                    
                                />
                            </div>
                            
                            
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Category</label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Category"
                                    type="text"
                                    value={category}
                                    onChange={(e) => { !specialCharacterCheck(String(e?.target?.value).toUpperCase()) && setCategory(String(e.target.value).toUpperCase()) }}
                                    maxLength={4}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Ticketing Fee</label>
                                <input
                                type='number'
                                    className="form-control cm-input"
                                    placeholder="Enter Ticketing Fee"
                                    value={ticketingFee}
                                    onChange={(e)=>{checkECharacter(e?.target?.value) && setTicketingFee(e.target.value)}}
                                />
                            </div>

                            
                            {/* <div className="col-md-3 cm-col">
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Min/Max Stay </label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Min "
                                            value={minmaxStay}
                                            onChange={(e) => { setMinmaxStay(String(e.target.value)) }}
                                        />
                                    </div>
                                </div>
                            </div> */}

                            <div className="col-md-3 cm-col">
                                <div className="row">
                                    {/* <div className="col-md-6 cm-col"> */}
                                        <label className="cm-head-label">Source </label>
                                        <input
                                            className="form-control cm-input"
                                            placeholder="Enter Source"
                                            value={classCodeDescription}
                                            onChange={(e) => { setClassCodeDescription(String(e.target.value?.toUpperCase())) }}
                                        />
                                    {/* </div> */}
                                </div>
                            </div>
                        </div>

                        <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Rules</span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>

                        </div>
                            <label className="cm-head-label mt-2">AGE</label>
                        <div className="row ">

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Infant Below</label>
                                <input
                                    className="form-control cm-input"
                                    placeholder="Enter Age"
                                    value={ageRestrictionsInfantAge}
                                    type='number'
                                    onChange={(e)=> checkECharacter(e?.target?.value) && setAgeRestrictionsInfantAge(e.target.value)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Applicable On</label>
                                        <FormControlLabel control={<Radio color="primary" checked={ageRestrictionsInfantAgeApplicableOn === "DEPARTURE" ? true : false} onClick={(e) => ageRestrictionsInfantAgeApplicableOn === "DEPARTURE" ? setAgeRestrictionsInfantAgeApplicableOn("") : setAgeRestrictionsInfantAgeApplicableOn("DEPARTURE")} />} label="Departure"
                                />
                                        <FormControlLabel control={<Radio color="primary" checked={ageRestrictionsInfantAgeApplicableOn === "ARRIVAL" ? true : false} onClick={(e) => ageRestrictionsInfantAgeApplicableOn === "ARRIVAL" ? setAgeRestrictionsInfantAgeApplicableOn("") : setAgeRestrictionsInfantAgeApplicableOn("ARRIVAL")} />} label="Return"
                                />{" "}
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Child From 2 To </label>
                                <input
                                    type='number'
                                    className="form-control cm-input"
                                    placeholder="Enter Age"
                                    value={ageRestrictionsChildAge}
                                    onChange={(e)=> checkECharacter(e?.target?.value) && setAgeRestrictionsChildAge(e.target.value)}
                                />

                            </div>
                            {/* <div className="col-md-3 cm-col">

                                <div className="cm-col">
                                    <label className="cm-head-label">Junior between</label>
                                    <div className="d-flex ">
                                        <div className='classCount mr-2'>
                                            <button className='classIncress' onClick={()=>{if(juniorAgeFrom > 0){setJuniorAgeFrom(juniorAgeFrom-1)}}}>-</button>
                                            <input className="classCountinput" type="text" value={juniorAgeFrom} disabled/>
                                            <button className='classDecress' onClick={()=>{if(juniorAgeFrom < 100){setJuniorAgeFrom(juniorAgeFrom+1)}}}>+</button>
                                        </div>
                                        <div className='classCount'>
                                            <button className='classIncress' onClick={()=>{if(juniorAgeTo > 0){setJuniorAgeTo(juniorAgeTo-1)}}}>-</button>
                                            <input className="classCountinput" type="text" value={juniorAgeTo} disabled/>
                                            <button className='classDecress'onClick={()=>{if(juniorAgeTo < 100){setJuniorAgeTo(juniorAgeTo+1)}}}>+</button>
                                        </div>
                                    </div>

                                </div>
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-md-12 mb-4">
                                <label className="cm-head-label">Notes for age</label>
                                <label className="cm-head-label">  Infant etkt not allowed with some codeshared flights or interligne carriers.Fees and adv purchase apply for paperticket. Bebe Etkt non permis avec certains vols partages ou interlignes. Frais et delais d achat pour demander un billet papier.</label>

                            </div>

                        </div>
                        <div className="row">
                            <div className="col-md-6 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">OSI </label>
                                    <Checkbox color="primary" checked={bulkEmpty?.OSI} onChange={() => handleBulkEdit("OSI")} />
                                </div>
                                <textarea className="form-control cm-input" style={{ "height": "90px" }} placeholder="Enter OSI" value={osi} onChange={(e)=> setOsi(e.target.value?.toUpperCase())} disabled={bulkEmpty?.OSI}/>
                            </div>
                            <div className="col-md-6 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">Branch files</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.branchFiles} onChange={() => handleBulkEdit("branchFiles")} />
                                </div>
                                <FormControlLabel control={<Checkbox color="primary" disabled={bulkEmpty?.branchFiles} value={permitBranchPNR} onChange={()=> setpermitBranchPNR(!permitBranchPNR)} />} label="Branch files not permitted" />
                            </div>
                        </div>

                        
                        <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Ticket By / Changes</span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            {/* <div className="col-md-3"> OPTION DATE</div> */}
                            <div className="card-body">
                                <div className="cm-head-2 mb-4">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Option By Date</span>
                                    </div>
                                </div>
                                {optionDates?.map((item, i) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Departure Window </label>
                                                <input className="form-control cm-input" name='departureWindow' type='number' placeholder="Enter Departure Window" value={item.departureWindow} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "option", i)} />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Days After Reservation </label>
                                                <input className="form-control cm-input" name='daysAfterReservation' type='number' placeholder="Enter Days After Reservation" value={item.daysAfterReservation} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "option", i)} />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Days Before Departure </label>
                                                <input className="form-control cm-input" name='daysBeforeDeparture' type='number' placeholder="Days Before Departure" value={item.daysBeforeDeparture} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "option", i)} />
                                            </div>
                                            <div className="col-md-3 d-flex align-items-end">
                                                <div className='setD-flex ms-2'>
                                                    <Button
                                                        className="BulkUpdate__removeBtn me-2"
                                                        onClick={() => handleRemoveOptionDate(i)}
                                                        disabled={optionDates.length === 1}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </Button>

                                                    {(i === optionDates.length - 1 && i < 3) && (
                                                        <Button className='BulkUpdate__AddBtn' onClick={handleAddOptionDate}>
                                                            <i className="fas fa-plus-circle"></i>
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="row mt-4 cm-col">
                            {/* <div className="col-md-3"> TICKET BY DATE</div> */}
                            <div className="card-body">
                                <div className="cm-head-2 mb-4">
                                    <div className="d-flex justify-content-between">
                                        <span className="">Ticket By Date</span>
                                    </div>
                                </div>
                                {ticketDates?.map((item, i) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Departure Window </label>
                                                <input className="form-control cm-input" type='number' name='departureWindow' placeholder="Enter Departure Window" value={item.departureWindow} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "ticket", i)} />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Days After Reservation </label>
                                                <input className="form-control cm-input" type='number' name='daysAfterReservation' placeholder="Enter Days After Reservation" value={item.daysAfterReservation} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "ticket", i)} />
                                            </div>
                                            <div className="col-md-3">
                                                <label className="cm-head-label">Days Before Departure </label>
                                                <input className="form-control cm-input" type='number' name='daysBeforeDeparture' placeholder="Days Before Departure" value={item.daysBeforeDeparture} onChange={(e) => checkECharacter(e?.target?.value) && changeOptionTicket(e, "ticket", i)} />
                                            </div>
                                            <div className="col-md-3 d-flex align-items-end">
                                                {
                                                    <div className='setD-flex ms-2'>
                                                        <Button
                                                            className="BulkUpdate__removeBtn me-2"
                                                            onClick={() => handleRemoveTicketDate(i)}
                                                            disabled={ticketDates.length === 1}
                                                        >
                                                            <i className="fas fa-trash-alt"></i>
                                                        </Button>

                                                        {(i === ticketDates.length - 1 && i < 3) && (
                                                            <Button className='BulkUpdate__AddBtn' onClick={handleAddTicketDate}>
                                                                <i className="fas fa-plus-circle"></i>
                                                            </Button>
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        {/* <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Routings</span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Routing Info Source </label>
                                <input className="form-control cm-input" placeholder="Enter Routing info source" value={classRoutings} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setClassRoutings(e.target.value)}/>
                            </div>
                        </div> */}

                        <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Price At Sabre</span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Disable auto-ticketing</label>
                                <FormControlLabel control={<Radio color="primary" checked={disableAutoTicketing == true ? true : false } onClick={()=>disableAutoTicketing == true ? setDisableAutoTicketing(null) :setDisableAutoTicketing(true)}/>} label="True" />
                                <FormControlLabel control={<Radio color="primary" checked={disableAutoTicketing == false ? true : false} onClick={()=>disableAutoTicketing == false ? setDisableAutoTicketing(null) :setDisableAutoTicketing(false)}/>} label="False" />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">PUC allowed</label>
                                <FormControlLabel control={<Radio color="primary" checked={(disablePriceUnitConcept == true) ? true : false} onClick={()=>disablePriceUnitConcept == true ? setDisablePriceUnitConcept(null) :setDisablePriceUnitConcept(true)}/>} label="True" />
                                <FormControlLabel control={<Radio color="primary" checked={(disablePriceUnitConcept == false) ? true : false} onClick={()=>disablePriceUnitConcept == false ? setDisablePriceUnitConcept(null) :setDisablePriceUnitConcept(false)}/>} label="False" />
                            </div>

                            <div className="col-md-3 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <FormControlLabel control={<Checkbox color="primary" checked={issueAsBulk} disabled={bulkEmpty?.issueAsBulk} onChange={()=>setIssueAsBulk(!issueAsBulk)}/>} label="Issue ticket as bulk only" />
                                    <Checkbox color="primary" checked={bulkEmpty?.issueAsBulk} onChange={() => handleBulkEdit("issueAsBulk")} />
                                </div>
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Pax Type</label>
                                <RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name={`SearchFareByradioGroup-${Math.random()}`}
                                    value={fareType}
                                >
                                    {fareOptions.map(({ label, value }) => (
                                        <FormControlLabel
                                            key={value}
                                            control={
                                                <Radio
                                                    color="primary"
                                                    value={value}
                                                    checked={fareType === value}
                                                    onClick={() =>
                                                        fareType === value ? setFareType("") : setFareType(value)
                                                    }
                                                />
                                            }
                                            label={label}
                                        />
                                    ))}
                                </RadioGroup>


                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-12 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">ACCOUNT CODE</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.accountCode} onChange={() => handleBulkEdit("accountCode")} />
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">VIT</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.accountCode} value={accountCodeVIT} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setAccountCodeVIT(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">SKY</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.accountCode} value={accountCodeSKY} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setAccountCodeSKY(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">DFW</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.accountCode} value={accountCodeDFW} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setaccountCodeDFW(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">FUN</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.accountCode} value={accountCodeFUN} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setaccountCodeFUN(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">TC</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.accountCode} value={accountCodeTC} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setaccountCodeTC(e.target.value?.toUpperCase())}/>
                            </div>
                        </div>

                        <div className='row'>
                            <div className="col-md-12 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">TICKET DESIGNATOR</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.ticketDesignator} onChange={() => handleBulkEdit("ticketDesignator")} />
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">VIT</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.ticketDesignator} value={ticketDesignatorVIT} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setTicketDesignatorVIT(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">SKY</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.ticketDesignator} value={ticketDesignatorSKY} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setTicketDesignatorSKY(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">DFW</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.ticketDesignator} value={ticketDesignatorDFW} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setTicketDesignatorDFW(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">FUN</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.ticketDesignator} value={ticketDesignatorFUN} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setTicketDesignatorFUN(e.target.value?.toUpperCase())}/>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">TC</label>
                                <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.ticketDesignator} value={ticketDesignatorTC} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setTicketDesignatorTC(e.target.value?.toUpperCase())}/>
                            </div>
                        </div>

                        {/* <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Remarks</span>
                                <div className="cm-head-checkbox d-flex">
                                </div>
                            </div>
                        </div>

                        <div className='row mt-4'>
                            <div className="col-md-6 cm-col">
                                <label className="cm-head-label">INTAIR</label>
                                <div className='row mt-4'>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">French</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksVITFR} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksVITFR(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">English</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksVITENG} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksVITENG(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 cm-col">
                                <label className="cm-head-label">SKYLINK</label>
                                <div className='row mt-4'>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">French</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksSKYFR} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksSKYFR(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">English</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksSKYENG} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksSKYENG(e.target.value)}/>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className='row'>
                            <div className="col-md-6 cm-col">
                                <label className="cm-head-label">FUN SUN</label>
                                <div className='row mt-4'>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">French</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksFUNFR} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksFUNFR(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">English</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksFUNENG} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksFUNENG(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 cm-col">
                                <label className="cm-head-label">DFW</label>
                                <div className='row mt-4'>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">French</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksDFWFR} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksDFWFR(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">English</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksDFWENG} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksDFWENG(e.target.value)}/>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='row '>
                            <div className="col-md-6 cm-col">
                                <label className="cm-head-label">TC</label>
                                <div className='row mt-4'>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">French</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksTCFR} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksTCFR(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">English</label>
                                        <input className="form-control cm-input" placeholder="" value={remarksTCENG} onChange={(e)=> !specialCharacterCheck(String(e?.target?.value)) && setRemarksTCENG(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    </>
                    :null}

                    {checkBoxObject?.prixs?.length ?
                    <>
                    <div className="row headerCollap">
                        <div className="col-12">
                            <p className="headerTitle">Prix</p>
                        </div>
                    </div>

                    <div>
                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Carrier</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Origin</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />

                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Destination</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />

                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Trip Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Contract Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Fare Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Branded Fare</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Cabin Type</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Classes</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Brand</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Ticketing Fee</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>

                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">EDR Date</label>
                                <input label='Validating Carrier'
                                    className="form-control cm-input autoCapitalise custom-disabled-field "
                                    disabled={(true)}
                                />
                            </div>
                        </div>


                        <div className="row align-items-end">
                            <div className="col-md-6 cm-col">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Valid From</label>
                                        {/* <input type="date" className="form-control cm-input-date" /> */}
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker disablePast className='BulkUpdate__DatePicker' value={validFrom} onChange={(date) => { setValidFrom(moment .utc(date).format("YYYY-MM-DD")) }} />
                                        </MuiPickersUtilsProvider> */}
                                        <CustomDateInput
                                            value={validFrom}
                                            onChange={setValidFrom}
                                            // label="Valid From"
                                            className="BulkUpdate__DatePicker"
                                            // minDate={new Date()}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label className="cm-head-label">Valid To</label>
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker className='BulkUpdate__DatePicker' minDate={validFrom} value={validTo} onChange={(date) => { setValidTo(moment .utc(date).format("YYYY-MM-DD")) }} />
                                        </MuiPickersUtilsProvider> */}
                                        <CustomDateInput
                                            value={validTo}
                                            onChange={setValidTo}
                                            // label="Valid To"
                                            className="BulkUpdate__DatePicker"
                                            // minDate={validFrom}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">Last Ticketing Date</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.lastTicketingDate} onChange={() => handleBulkEdit("lastTicketingDate")} />
                                </div>
                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className='BulkUpdate__DatePicker' value={prixLastTicketingDate} onChange={(date) => { setPrixLastTicketingDate(moment .utc(date).format("YYYY-MM-DD"))}} />
                                </MuiPickersUtilsProvider> */}
                                <CustomDateInput
                                    value={prixLastTicketingDate}
                                    onChange={setPrixLastTicketingDate}
                                    // label="Last Ticketing Date"
                                    className="BulkUpdate__DatePicker"
                                />
                            </div>
                            
                            <div className="col-md-3 cm-col">
                                <div className='bulkEmptyLabel'>
                                    <label className="cm-head-label">Last Return Date</label>
                                    <Checkbox color="primary" checked={bulkEmpty?.lastReturnDate} onChange={() => handleBulkEdit("lastReturnDate")} />
                                </div>
                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className='BulkUpdate__DatePicker' value={prixLastReturnDate} onChange={(date) => { setPrixLastReturnDate(moment .utc(date).format("YYYY-MM-DD"))}} />
                                </MuiPickersUtilsProvider> */}
                                <CustomDateInput
                                    value={prixLastReturnDate}
                                    onChange={setPrixLastReturnDate}
                                    // label="Last Return Date"
                                    className="BulkUpdate__DatePicker"
                                />
                            </div>
                            
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Prix Note</label>
                                <input className="form-control cm-input" placeholder="Enter Prix note" value={prixNote} onChange={({target})=>setPrixNote(target.value?.toUpperCase())}/>
                            </div>
                        </div>

                                    {/* new prix keys */}
                            <div className='cm-col'>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_adult} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR COMMISSION</label>
                                                            <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %'  value={commissionPercentage} onChange={({ target }) => checkECharacter(target?.value) && setCommissionPercentage(target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR MARKUP</label>
                                                            <input label='OUR MARKUP' className="form-control cm-input" type="number" placeholder='Enter $' value={markup} onChange={({ target }) => checkECharacter(target?.value) && setmarkup(target.value)}   />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label"> AGENCY COMMISSION</label>
                                                            <input
                                                                fullWidth
                                                                label="AGENCY COMMISSION"
                                                                className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field"
                                                                type="text"
                                                                placeholder="Enter %"
                                                                value={passBackCommission} 
                                                                onChange={({ target }) => checkECharacter(target?.value) && setPassBackCommission(target.value)} 
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">MIN SELL</label>
                                                            <input label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={minumumSellingPrice} onChange={(e) => checkECharacter(e?.target?.value) && setMinumumSellingPrice(e.target.value)}  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_child} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR COMMISSION</label>
                                                            <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={childCommissionPercentage} onChange={({ target }) => checkECharacter(target?.value) && setChildCommissionPercentage(target.value)}   />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR MARKUP</label>
                                                            <input label='OUR MARKUP' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={childMarkup} onChange={({ target }) => checkECharacter(target?.value) && setChildMarkUp(target.value)}  />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label"> AGENCY COMMISSION</label>
                                                            <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={childPassBackCommission} onChange={({ target }) => checkECharacter(target?.value) && setChildPassBackCommission(target.value)}   />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">MIN SELL</label>
                                                            <input label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={minumumSellingPrice} onChange={(e) => checkECharacter(e?.target?.value) && setMinumumSellingPrice(e.target.value)} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body">
                                        <div className="cm-head-2 mb-4">
                                            <div className="d-flex justify-content-between">
                                                <span className="">Prix</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-4 prix_iconBox">
                                                        <img src={icon_childfriendly} />
                                                    </div>
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR COMMISSION</label>
                                                            <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={infantCommissionPercentage} onChange={({target})=> checkECharacter(target?.value) && setInfantCommissionPercentage(target.value)}  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">

                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">OUR MARKUP</label>
                                                            <input label='OUR MARKUP' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={infantMarkUp} onChange={({target})=> checkECharacter(target?.value) && setInfantMarkUp(target.value)}  />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label"> AGENCY COMMISSION</label>
                                                            <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={infantPassBackCommission} onChange={({target})=> checkECharacter(target?.value) && setInfantPassBackCommission(target.value)}  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="row">
                                                    <div className="col-md-8">
                                                        <div className="cm-col">
                                                            <label className="cm-head-label">MIN SELL</label>
                                                            <input label='MIN SELL' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter $' value={minumumSellingPrice} onChange={(e)=> checkECharacter(e?.target?.value) && setMinumumSellingPrice(e.target.value)}  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className=" cm-head-2 mb-4 mr-8">
                                                    <div className="d-flex justify-content-between">
                                                        <span className="">Navcan (Surcharges)</span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_adult} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={adultCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setAdultCommissionOnYQNav(target.value)}  />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={adultPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setAdultPassBackCommissionOnYQNav(target.value)}  />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>
                                                <div className=" cm-head-2 mb-4">
                                                    <div className="d-flex justify-content-between">
                                                        <span className="">Carburant</span>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_adult} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={adultCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setAdultCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={adultPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setadultPassBackCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_child} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={childCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setChildCommissionOnYQNav(target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={childPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setChildPassBackCommissionOnYQNav(target.value)}  />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>

                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_child} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={childCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setChildCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={childPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setChildPassBackCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card Tariff__BorderB">
                                    <div className="card-body py-0">
                                        <div className='row'>
                                            <div className='col-md-6 prix_borderRight py-6'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_childfriendly} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={enfantCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setEnfantCommissionOnYQNav(target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' value={enfantPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setEnfantPassBackCommissionOnYQNav(target.value)} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 py-6'>

                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-4 prix_iconBox">
                                                                <img src={icon_childfriendly} />
                                                            </div>
                                                            <div className="col-md-8">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">OUR COMMISSION</label>
                                                                    <input label='OUR COMMISSION' className="form-control cm-input autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={enfantCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setEnfantCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <div className="cm-col">
                                                                    <label className="cm-head-label">AGENCY COMMISSION</label>
                                                                    <input label='AGENCY COMMISSION' className="form-control cm-input cm__inputW80 autoCapitalise custom-disabled-field" type="text" placeholder='Enter %' 
                                                                    value={enfantPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setEnfantPassBackCommissionOnYQ(target.value)}   
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </div>
                                    {/* new prix key ends */}

                                    {/* //start */}
                        {/* <div className="row">
                            <div className="col-md-12 cm-col">
                                <label className="cm-head-label">Prix Note Price</label>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">OUR COMMISSION </label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={adultCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setAdultCommissionOnYQ(target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setChildCommissionOnYQ(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">OUR MARKUP</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={markup} onChange={({target})=> checkECharacter(target?.value) && setmarkup(target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childMarkup} onChange={({target})=> checkECharacter(target?.value) && setChildMarkUp(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">AGENCY COMMISSION</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={adultPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setadultPassBackCommissionOnYQ(target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setChildPassBackCommissionOnYQ(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label"> MIN SELL</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={adultMinSelling} onChange={(e)=> checkECharacter(e?.target?.value) && setAdultMinSelling(e.target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childMinSelling} onChange={(e)=> checkECharacter(e?.target?.value) && setChildMinSelling(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Infant</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">

                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={enfantCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setEnfantCommissionOnYQ(target.value)}/>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Infant</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">

                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={infantMarkUp} onChange={({target})=> checkECharacter(target?.value) && setInfantMarkUp(target.value)}/>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Infant</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">

                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={enfantPassBackCommissionOnYQ} onChange={({target})=> checkECharacter(target?.value) && setEnfantPassBackCommissionOnYQ(target.value)}/>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Infant</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={infantMinSelling} onChange={(e)=> checkECharacter(e?.target?.value) && setInfantMinSelling(e.target.value)}/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 cm-col">
                                <label className="cm-head-label">Navcan (Surcharges)</label>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">OUR COMMISSION </label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={adultCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setAdultCommissionOnYQNav(target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setChildCommissionOnYQNav(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label"> </label>
                                <div className="row  mt-2">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Infant</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={enfantCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setEnfantCommissionOnYQNav(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">AGENCY COMMISSION</label>
                                <div className="row">
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Adult</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={adultPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setAdultPassBackCommissionOnYQNav(target.value)}/>
                                    </div>
                                    <div className="col-md-6 cm-col">
                                        <label className="cm-head-label">Child</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={childPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setChildPassBackCommissionOnYQNav(target.value)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">  </label>
                                <div className="row mt-2">
                                    <div className="col-md-6 cm-col ">
                                        <label className="cm-head-label">Infant</label>
                                        <input className="form-control cm-input" placeholder="Enter %" type='number' value={enfantPassBackCommissionOnYQNav} onChange={({target})=> checkECharacter(target?.value) && setEnfantPassBackCommissionOnYQNav(target.value)}/>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                                    {/* //end */}
                        <div className="cm-head-2">
                            <div className="d-flex justify-content-between">
                                <span className="">Exceptions </span>
                                <div className="cm-head-checkbox d-flex">
                                </div>

                            </div>
                        </div>
                            <div className="row">
                            <div className="col-md-12 cm-col">
                                <label className="cm-head-label">Blackout Dates</label>
                            </div>
                        {blackoutDatesRepetative.map((blackout,index)=>{return(

                            <>
                            <div className="col-md-3 cm-col">
                                <div className="d-flex align-items-center">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                color="primary"
                                                // checked={(airline.isMarkedForDelete)}
                                                onChange={(e) => {
                                                    onChangeForMultiple(Number(e.target.checked), index, 'isMarkedForDelete', blackoutDatesRepetative, setBlackoutDatesRepetative);
                                                    // blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE, index, e.target.checked);
                                                }}
                                            />
                                        }
                                        label=""
                                    />

                                    <div>
                                        <label className="cm-head-label">Start Date</label>
                                        {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardDatePicker className='BulkUpdate__DatePicker' disablePast value={blackout.fromDate?.length ? blackout.fromDate : null} onChange={(date)=>onChangeForMultiple(moment .utc(date).format("YYYY-MM-DD"), index,'fromDate',blackoutDatesRepetative, setBlackoutDatesRepetative)} />
                                        </MuiPickersUtilsProvider> */}
                                        <CustomDateInput
                                            value={blackout.fromDate?.length ? blackout.fromDate : null}
                                            className='BulkUpdate__DatePicker'
                                            onChange={(date)=>onChangeForMultiple(date, index,'fromDate',blackoutDatesRepetative, setBlackoutDatesRepetative)}
                                            minDate={new Date()}
                                            disabled={blackout.isMarkedForDelete}

                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">End Date</label>
                                {/* <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <KeyboardDatePicker className='BulkUpdate__DatePicker' minDate={blackout.fromDate} value={blackout.toDate?.length ? blackout.toDate : null} onChange={(date)=>onChangeForMultiple(moment .utc(date).format("YYYY-MM-DD"), index,'toDate', blackoutDatesRepetative, setBlackoutDatesRepetative)} />
                                </MuiPickersUtilsProvider> */}
                                <CustomDateInput
                                    value={blackout.toDate?.length ? blackout.toDate : null}
                                    className='BulkUpdate__DatePicker'
                                    onChange={(date) => onChangeForMultiple(date, index, 'toDate', blackoutDatesRepetative, setBlackoutDatesRepetative)}
                                    minDate={blackout.fromDate}
                                    disabled={blackout.isMarkedForDelete}
                                />
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label"></label>
                                <div className="row">
                                    <div className="col-md-6 ">
                                        <FormControlLabel control={<Checkbox color="primary" disabled={blackout.isMarkedForDelete} checked={Boolean(blackout.aller)} onChange={(e)=>onChangeForMultiple(Number(e.target.checked),index,'aller', blackoutDatesRepetative, setBlackoutDatesRepetative)}/>} label="Departure" />
                                    </div>
                                    <div className="col-md-6 ">
                                        <FormControlLabel control={<Checkbox color="primary" disabled={blackout.isMarkedForDelete} checked={Boolean(blackout.retour)} onChange={(e)=>onChangeForMultiple(Number(e.target.checked),index,'retour', blackoutDatesRepetative, setBlackoutDatesRepetative)}/>} label="Return" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 cm-col">
                                <label className="cm-head-label">Exception Type</label>
                                <div className="row">
                                    <div className="col-md-8 ">
                                        <Select
                                            className='BulkUpdate__DatePicker'
                                            value={blackout.exceptionType}
                                            onChange={(e)=>onChangeForMultiple(e.target.value,index,'exceptionType', blackoutDatesRepetative, setBlackoutDatesRepetative)}
                                            disabled={blackout.isMarkedForDelete}
                                        >
                                            <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                            <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                            <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                        </Select>
                                    </div>
                                    <div className="col-md-4 pl-0">
                               
                                        <div className='setD-flex'>
                                            <Button className="BulkUpdate__removeBtn " onClick={()=>{if(blackoutDatesRepetative.length > 1){let temp = [...blackoutDatesRepetative]; temp.splice(index, 1);setBlackoutDatesRepetative([...temp]);}}}><i className="fas fa-trash-alt"></i></Button>
                                            <Button className='BulkUpdate__AddBtn px-0' onClick={()=>{let temp = [...blackoutDatesRepetative]; temp.push({...blackoutDate});setBlackoutDatesRepetative([...temp]);}}><i className="fas fa-plus-circle"></i></Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </>
                        )})}
                        </div>
                    </div>
                    </>
                    :null}


                </div>
            </div >

                {checkBoxObject?.prixs?.length ?
                <div className="card cm-card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 cm-col">
                            <label className="cm-head-label">Blackout Days</label>
                        </div>
                        {checkBoxObject?.prixs?.length && blackoutDaysRepetative.map((day, index) => {
                            return (
                        <>
                        <div className="col-md-3 cm-col">
                            <div className="d-flex align-items-center">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            // checked={(airline.isMarkedForDelete)}
                                            onChange={(e) => {
                                                onChangeForMultiple(Number(e.target.checked), index, 'isMarkedForDelete', blackoutDaysRepetative, setBlackoutDaysRepetative);
                                                // blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE, index, e.target.checked);
                                            }}
                                        />
                                    }
                                    label=""
                                />
                                <div>
                                    <label className="cm-head-label">Days</label>
                                    <input className="form-control cm-input" placeholder="" disabled={day.isMarkedForDelete} value={day.day} onChange={(e) => !specialCharacterCheck(String(e?.target?.value)) && onChangeForMultiple(String(e.target.value).toUpperCase(), index, 'day', blackoutDaysRepetative, setBlackoutDaysRepetative)} />
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label"></label>
                            <div className="row">
                                <div className="col-md-6 ">
                                    <FormControlLabel control={<Checkbox color="primary" disabled={day.isMarkedForDelete} checked={Boolean(day?.aller)} onChange={(e)=>onChangeForMultiple(Number(e.target.checked),index,'aller', blackoutDaysRepetative, setBlackoutDaysRepetative)}/>} label="Departure" />
                                </div>
                                <div className="col-md-6 ">
                                    <FormControlLabel control={<Checkbox color="primary" disabled={day.isMarkedForDelete} checked={Boolean(day?.retour)} onChange={(e)=>onChangeForMultiple(Number(e.target.checked),index,'retour', blackoutDaysRepetative, setBlackoutDaysRepetative)}/>} label="Return" />
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">Exception Type</label>
                            <div className="row">
                                <div className="col-md-8 ">
                                    <Select className='BulkUpdate__DatePicker'
                                     value={day.exceptionType}
                                     disabled={day.isMarkedForDelete}
                                     onChange={(e)=>onChangeForMultiple(e.target.value,index,'exceptionType', blackoutDaysRepetative, setBlackoutDaysRepetative)}
                                     >
                                        <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                        <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                        <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                    </Select>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 cm-col">
                            <div className="row">
                                <div className="col-md-8 ">
                                </div>
                                <div className="col-md-4 pl-0">

                                    <div className='setD-flex mt-5'>
                                    <Button className="BulkUpdate__removeBtn " onClick={()=>{if(blackoutDaysRepetative.length > 1){let temp = [...blackoutDaysRepetative]; temp.splice(index, 1);setBlackoutDaysRepetative([...temp]);}}}><i className="fas fa-trash-alt"></i></Button>
                                    <Button className='BulkUpdate__AddBtn px-0' onClick={() => { let temp = [...blackoutDaysRepetative]; temp.push({ ...blackoutDay }); setBlackoutDaysRepetative([...temp]); }}><i className="fas fa-plus-circle"></i></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
            )
            })}
                    </div>
                </div>
            </div>
            : null
            }

            {checkBoxObject?.prixs?.length ?
                <div className="card cm-card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 cm-col">
                            <label className="cm-head-label">Blackout Airlines</label>
                        </div>
                        {checkBoxObject?.prixs?.length && blackoutAirlinesRepetative.map((airline, index) => {
                            return (
                        <>
                        <div className="col-md-6 cm-col d-flex">
                            <FormControlLabel
                                    control={
                                        <Checkbox
                                        color="primary"
                                        checked={Boolean(airline.isMarkedForDelete)}
                                        onChange={(e) => {
                                            onChangeForMultiple(Number(e.target.checked), index, 'isMarkedForDelete', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative);
                                            blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE, index, e.target.checked);
                                        }}
                                        />
                                    }
                                    label=""
                                    />
                                    <div style={{ width: '100%' }}>
                            <label className="cm-head-label">Carrier Code</label>
                            <input className="form-control cm-input" placeholder="" value={airline.carrierCode} onChange={(e)=>onChangeForMultiple(String(e.target.value).toUpperCase(),index,'carrierCode', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative)} onBlur={(e) => blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.UPDATE_DISPLAY_TEXT, index, `${e.target.value}`)} disabled={airline.isMarkedForDelete}/>
                            </div>
                        </div>
                        {/* <div className="col-md-3 cm-col">
                            <div className="row">
                                <div className="col-md-6 ">
                                    <label className="cm-head-label">From</label>
                                    <input className="form-control cm-input" placeholder=" " value={airline.flightNumberFrom} onChange={(e)=>onChangeForMultiple(String(e.target.value)?.toUpperCase(),index,'flightNumberFrom', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative)}/>
                                </div>
                                <div className="col-md-6 ">
                                    <label className="cm-head-label">to</label>
                                    <input className="form-control cm-input" placeholder=" " value={airline.flightNumberTo} onChange={(e)=>onChangeForMultiple(String(e.target.value)?.toUpperCase(),index,'flightNumberTo', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative)}/>
                                </div>
                            </div>

                        </div> */}
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label"></label>
                            <div className="row">
                                <div className="col-md-4 ">
                                    <FormControlLabel control={<Checkbox disabled={airline.isMarkedForDelete} color="primary" checked={Boolean(airline.aller)} onChange={(e)=>{onChangeForMultiple(Number(e.target.checked),index,'aller', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative); blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_ALLER, index)}}/>} label="Departure" />
                                </div>
                                <div className="col-md-4 ">
                                    <FormControlLabel control={<Checkbox disabled={airline.isMarkedForDelete} color="primary" checked={Boolean(airline.retour)} onChange={(e)=>{onChangeForMultiple(Number(e.target.checked),index,'retour', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative);blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.TOGGLE_RETOUR, index)}}/>} label="Return" />
                                </div>
                                
                            </div>
                        </div>

                        <div className="col-md-3 cm-col">
                            <div className="row">
                                <div className="col-md-8 ">
                                    <label className="cm-head-label">Exception Type</label>
                                    <Select className='BulkUpdate__DatePicker'
                                    value={airline.exceptionType}
                                    disabled={airline.isMarkedForDelete}
                                    onChange={(e)=>{onChangeForMultiple(e.target.value,index,'exceptionType', blackoutAirlinesRepetative, setBlackoutAirlinesRepetative); blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.CHANGE_EXCEPTION_TYPE, index, e.target.value)}}
                                    >
                                        <MenuItem value={'BlackOut'}>BlackOut</MenuItem>
                                        <MenuItem value={'Reduction'}>Reduction</MenuItem>
                                        <MenuItem value={'Supplement'}>Supplement</MenuItem>
                                    </Select>
                                </div>
                                <div className="col-md-4 pl-0 mt-5">
                                    <div className='setD-flex'>
                                    <Button className="BulkUpdate__removeBtn " onClick={()=>{if(blackoutAirlinesRepetative.length > 1){let temp = [...blackoutAirlinesRepetative]; temp.splice(index, 1);setBlackoutAirlinesRepetative([...temp])};blackOutCarrierCTA(BLACKOUT_CARRIER_ACTION.DELETE_INDEX, index)
                                    }}><i className="fas fa-trash-alt"></i></Button>
                                    <Button className='BulkUpdate__AddBtn px-0' onClick={() => { let temp = [...blackoutAirlinesRepetative]; temp.push({ ...blackoutAirline }); setBlackoutAirlinesRepetative([...temp]); }}><i className="fas fa-plus-circle"></i></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                            )
                        })}
                    </div>
                </div>
            </div>
            : null}

            {checkBoxObject?.prixs?.length ?
            <div className="card cm-card">
                <div className="card-body">
                    <div className="cm-head-2">
                        <div className="d-flex justify-content-between">
                            <span className="">Emission </span>
                            <div className="cm-head-checkbox d-flex">
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 cm-col">
                            <div className='bulkEmptyLabel'>
                                <label className="cm-head-label">Endorsement</label>
                                <Checkbox color="primary" checked={bulkEmpty?.endorsement} onChange={() => handleBulkEdit("endorsement")} />
                            </div>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">VIT</label>
                            <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.endorsement} value={endorsementVIT} onChange={(e)=>setEndorsementVIT(e.target.value?.toUpperCase())}/>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">SKY</label>
                            <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.endorsement} value={endorsementSKY} onChange={(e)=>setEndorsementSKY(e.target.value?.toUpperCase())}/>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">DFW</label>
                            <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.endorsement} value={endorsementDFW} onChange={(e)=>setEndorsementDFW(e.target.value?.toUpperCase())}/>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">FUN</label>
                            <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.endorsement} value={endorsementFUN} onChange={(e)=>setEndorsementFUN(e.target.value?.toUpperCase())}/>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">TC</label>
                            <input className="form-control cm-input" placeholder="" disabled={bulkEmpty?.endorsement} value={endorsementTC} onChange={(e)=>setEndorsementTC(e.target.value?.toUpperCase())}/>
                        </div>
                    </div>

                </div>
            </div>
            :null}
{console.log("tourCodeRepetative",tourCodeRepetative)}
            {checkBoxObject?.prixs?.length ?
                
                <div className="card cm-card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-12 cm-col">
                            <label className="cm-head-label">Tour Code</label>
                        </div>
                    </div>
                    {tourCodeRepetative.map((tourcodeVal, index)=>{return(
                    <div className="row">
                        <div className='col-md-3 cm-col'>
                            <div className="d-flex align-items-center">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            color="primary"
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    deleteTourCodeRow(index, tourCodeRepetative, setTourCodeRepetative);
                                                } else {
                                                    // Restore delete = false
                                                    onChangeForMultiple(false, index, 'isMarkedForDelete', tourCodeRepetative, setTourCodeRepetative);
                                                }
                                            }}
                                        />
                                    }
                                    label=""
                                />
                                <div>
                                    <div className="">
                                        <label className="cm-head-label">Office</label>
                                        <select
                                            className="form-control cm-input"
                                            value={tourcodeVal?.marketCode}
                                            onChange={(e) =>
                                                onChangeForMultiple(
                                                    e.target.value,
                                                    index,
                                                    "marketCode",
                                                    tourCodeRepetative,
                                                    setTourCodeRepetative
                                                )
                                            }
                                            disabled={tourcodeVal?.isMarkedForDelete}
                                        >
                                            <option value="">-- Select --</option>
                                            {tourCodeDropdown.map((code) => (
                                                <option key={code} value={code}>
                                                    {code}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">Adult</label>
                            <div className="row">
                                <div className="col-md-6 cm-col">

                                    <input
                                        className="form-control cm-input"
                                        placeholder=" "
                                        value={tourcodeVal?.passengerType?.includes("ADULT") ? tourcodeVal?.tourCodes : ""}
                                        disabled={tourcodeVal?.isMarkedForDelete}
                                        onChange={(e) => { onChangeForMultiple(e.target.value?.toUpperCase(), index, "tourCodes", tourCodeRepetative, setTourCodeRepetative); { onChangeForMultiple(tourcodeVal?.passengerType?.includes("ADULT")
                                                                                            ? tourcodeVal?.passengerType
                                                                                            : [...tourcodeVal?.passengerType, 'ADULT'], index, "passengerType", tourCodeRepetative, setTourCodeRepetative) } }}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">Child</label>
                            <div className="row">
                                <div className="col-md-6 cm-col">

                                    <input
                                        className="form-control cm-input"
                                        placeholder=" " 
                                        value={tourcodeVal?.passengerType?.includes("CHILD") ? tourcodeVal?.tourCodes : ""}
                                        disabled={tourcodeVal?.isMarkedForDelete}
                                        onChange={(e) => { onChangeForMultiple(e.target.value?.toUpperCase(), index, "tourCodes", tourCodeRepetative, setTourCodeRepetative); { onChangeForMultiple(tourcodeVal?.passengerType?.includes("CHILD")
                                                                                            ? tourcodeVal?.passengerType
                                                                                            : [...tourcodeVal?.passengerType, 'CHILD'], index, "passengerType", tourCodeRepetative, setTourCodeRepetative) } }}
                                    />
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 cm-col">
                            <label className="cm-head-label">Infant</label>
                            <div className="row">
                                <div className="col-md-6 cm-col">
                                    <input
                                        className="form-control cm-input"
                                        placeholder=" "
                                        value={tourcodeVal?.passengerType?.includes("INFANT") ? tourcodeVal?.tourCodes : ""}
                                        disabled={tourcodeVal?.isMarkedForDelete}
                                        onChange={(e) => { onChangeForMultiple(e.target.value?.toUpperCase(), index, "tourCodes", tourCodeRepetative, setTourCodeRepetative); { onChangeForMultiple(tourcodeVal?.passengerType?.includes("INFANT")
                                                                                            ? tourcodeVal?.passengerType
                                                                                            : [...tourcodeVal?.passengerType, 'INFANT'], index, "passengerType", tourCodeRepetative, setTourCodeRepetative) } }}
                                    />
                                </div>
                                <div className="col-md-6 cm-col ">

                                    <div className='setD-flex'>
                                    <Button className="BulkUpdate__removeBtn " onClick={()=>{if(tourCodeRepetative.length > 1){let temp = [...tourCodeRepetative]; temp.splice(index, 1);setTourCodeRepetative([...temp]);}}}><i className="fas fa-trash-alt"></i></Button>
                                    <Button className='BulkUpdate__AddBtn px-0' onClick={() => { let temp = [...tourCodeRepetative]; temp.push({ ...tourCode }); setTourCodeRepetative([...temp]); }}><i className="fas fa-plus-circle"></i></Button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    )})}
                </div>
            </div>
            
            : null
            }

            <div className="card cm-card">
                <div className="card-body">
                    <div className="row cm-col">
                        <div className="col-md-12 cm-col text-right">
                            <button className="cm-secondary-btn mr-2 " onClick={()=>history.push('/newcontractlist')}>Cancel</button>
                            <button className='cm-primary-btn' onClick={saveHandle}>Save</button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default BulkUpdate